import { ContractAwardCriteriaDTO } from './../../api/plyca-dtos-v2';
import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import {
  Component,
  OnInit,
  Optional,
  ElementRef,
  OnDestroy,
  AfterContentInit
} from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ContractDTO,
  ResultTypeDTO,
  ContractLotCPVDTO,
  ContractTendererLotDTO,
  ContractLotDTO,
  ClassificationSchemaLotDTO,
  ClassificationSchemaDTO,
  ContractSpecialConditionsLotDTO,
  ContractSpecialConditionsDTO,
  LotDTO,
  ContractAwardCriteriaLotDTO,
  ContractCPVDTO,
  CompanyDTO,
  ContractTendererDTO,
  ContractProcurementProjectInformationDTO,
  ContractOrganizationalInfoDTO,
  ContractPlannedPeriodDTO,
  CPVDTO,
  ConsortiumParticipationDTO,
  ActionParameterDefinitionDTO,
  HomologationSystemDTO,
  ProcurementProjectClassificationDTO,
  ContractClassificationDTO,
  WarrantyLotDTO,
  WarrantyDTO,
  ContractWarrantyDTO,
  RepresentativeDTO
} from '../../api/plyca-dtos-v2';
import { WorkContractDTO, DocumentDTO, MasterDataDTO, getSimpleIdentifierFromString, SearchSelectionResultDTO, TaskDTO, DivisionDTO } from '../../api/plyca-dtos';
import { FormConfig } from '../../components/forms/form.objects';
import { Configuration } from '../../conf/app.constants';
import * as lodash from 'lodash';
import { forkJoin, of, Observable, throwError } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { searchGenericComponent, SearchSettingDTOModal } from '../../components/search/searchGeneric.component';
import { searchCPVComponent } from '../../components/searchCPV/searchCPV.component';
import { PaginationDTO } from '../../api/PaginationModel';
import { ContractValidations } from './contract.validation';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { RelatedOrderProjectDTO, OrderProjectDTO } from '../../api/sarga-dtos';
import { SearchConfig } from '../../api/contract-notice-dto';
import { ServiceLocator } from '../../ServiceLocator';
import { UserService } from '../../user.service';
import { PropertyService } from '../../properties/property.service';
import { ContractRequestedMaterialListComponent } from '../requestedMaterial/ContractRequestedMaterialList.component';



export class ContractModel {

  dto: ContractDTO;
  ui: {
    isContextWork?: boolean,
    isAnulationMode?: boolean,
    isEditableFinalEndDate?: boolean,
    isEditableAwardAmount?: boolean,
    isRectificationMode?: boolean,
    isAutomaticMode?: boolean,
    isVisibleClassificationCompany?: boolean,
    listaLotes?: Array<any>,
    complementarySystem?: MasterDataDTO,
    applicableLegislation?: MasterDataDTO,
    accountingMotivation?: MasterDataDTO,
    type?: MasterDataDTO,
    typeCode?: MasterDataDTO,
    typeCodeMode?: string,
    apportioned?: boolean,
    homologationSystem?: HomologationSystemDTO,
    desgloseLotes?: Array<ContractLotDTO>,
    urgencyCode?: MasterDataDTO
    companySelected?: ContractTendererDTO;
    companySelectedCBAM?: CompanyDTO;
    subTypeCodeGoods?: MasterDataDTO;
    subTypeCodeServices?: MasterDataDTO;
    approvalAwardDate?: Date;
    approvalAwardDateMinor?: Date;
    isEditableSupport?: boolean;
    isSettlementMode?: boolean;
    externalUnitVisible?: boolean;
    modeRegisterNumber?: string;
    isEditableRegisterNumber?: boolean;
    isEditableReservedContractType?: boolean;
    reservedEntityType1_2022_Aymad?: string;
    outSourcingType1_2022_Aymad?: string;
    originalContractAM?: ContractDTO;
    originalContractSDA?: ContractDTO;
    actualUser?: string;
    activeTemporayPeriodOrganizationalChange?: boolean;
    enabledPreviousOrganizationalUnitRegistration?: boolean;
    selectedOrganizationalInfo?: ContractOrganizationalInfoDTO;
    isVisibleConcesion?: boolean;
  }
}

@Component({
  selector: 'contract-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [ContractValidations]
})
export class ContractComponent
  extends BaseFormComponent<ContractDTO, ContractModel>
  implements OnInit, OnDestroy, AfterContentInit {

  private identifier: string;
  workContract: WorkContractDTO;
  infoLoaded = false;
  contract: ContractDTO;
  projectLoaded = false;
  existProject = false;
  private userService: UserService;
  externalUnitVisible = false;

  private reservedEntityType1_2022_Aymad: string;
  private outSourcingType1_2022_Aymad: string;

  showRequestedMaterialLotes = false;

  public static resetChange(changes?: any) {
    let oldValue = changes.oldValue;
    let newValue = changes.newValue;

    let reset = ((oldValue && newValue) && (oldValue.identifier !== newValue.identifier)) || (newValue === undefined);
    console.log('======resetChange', reset);
    return reset;
  }

  // @ViewChild('rejectionPanelContainer', { read: ViewContainerRef })
  // rejectionPanelContainer: ViewContainerRef;

  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    private contractValidations: ContractValidations,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService,
    private propertyService: PropertyService,
  ) {
    super(elem);



    this.subscribe(this.activatedRoute.params, params => {
      this.identifier = params['id'];
      this.subscribe(
        forkJoin([
          this.propertyService.getProperty('FILTRO_TIPOENTIDAD_FRC', '')
            .pipe(catchError((error: any) => {
              console.log(error)
              return of(undefined)
            })),
          this.propertyService.getProperty('FILTRO_TIPOSUBCONTRATACION_FRC', '')
            .pipe(catchError((error: any) => {
              console.log(error)
              return of(undefined)
            }))
        ]),
        ([resultPropertyTipoEntidadFRC, resultPropertyTipoSubonctratacion]) => {
          if (resultPropertyTipoEntidadFRC) {
            this.reservedEntityType1_2022_Aymad = resultPropertyTipoEntidadFRC;
          }
          if (resultPropertyTipoSubonctratacion) {
            this.outSourcingType1_2022_Aymad = resultPropertyTipoSubonctratacion;
          }
        },
        error => {
          this.plycaErrorHandler.showServerError(error)
        });
    })

    /*this.subscribe(this.activatedRoute.params, params => {
      this.identifier = params['id'];
      this.subscribe(this.propertyService.getProperty('FILTRO_TIPOENTIDAD_FRC', ''), (value: string) => {
        if (value !== 'undefined' && value !== '') {
          this.reservedEntityType1_2022_Aymad = value;
        }
      });
    })*/
    /*this.subscribe(this.activatedRoute.params
      .pipe(tap(params => (this.identifier = params['id'])))
    );*/
    this.subscribe(router.events, e => {
      if (e instanceof NavigationStart) {
        if (this.task !== undefined) {
          this.cleanWorkContract();
        }
      }
    });

    this.userService = ServiceLocator.injector.get(UserService);
    let supportProfile = this.appConfig.getValue('user.supportProfile');
    this.externalUnitVisible = this.userService.hasRoles(supportProfile);

  }
  ngOnInit(): void {

    super.ngOnInit();
    // carga de la información de la ayuda
    let helpTags = [];
    helpTags.push(HelpType.NEW_CONTRACT);
    // No se puede cargar en el constructor por que this.task no tiene valor al abrirse la instacia desde basetask
    if (this.task) {
      // ayuda con tarea
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap((taksHelpTags) => {
          helpTags = helpTags.concat(taksHelpTags);
          return this.helpService.showContextHelpObservable(helpTags)
        })));
    } else {

      this.subscribe(
        this.helpService.showContextHelpObservable(helpTags));
    }
  }
  ngAfterContentInit(): void {
    // this.createRejectionPanel();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    if (this.model.ui.isAutomaticMode) {
      return 'contracts/contractInterfaceRecoSettings.json';
    } else {
      return this.getFormReplyca();
    }

  }

  getFormReplyca(): string {
    if (this.model && this.model.dto && this.model.dto.context
      && this.model.dto.context.configurations &&
      this.model.dto.context.configurations.formReplyca
      && this.model.dto.context.configurations.formReplyca.value != '') {
      return this.model.dto.context.configurations.formReplyca.value;
    } else {
      return 'contracts/contractInterfaceRecoSettings.json';
    }
  }


  getServiceURL(): string {
    return this.configuration.CONTRACTS_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task) {
      identifier = undefined;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }

  dtoToModel(dto: ContractDTO): Observable<ContractModel> {
    let model = new ContractModel();
    model.dto = dto;
    model.ui = {
      isSettlementMode: false,
      isContextWork: false,
      activeTemporayPeriodOrganizationalChange: false,
      enabledPreviousOrganizationalUnitRegistration: true
    };

    model.ui.apportioned = false;
    model.ui.isAutomaticMode = false;
    model.ui.actualUser = this.userService.getUserId();

    model.ui.externalUnitVisible = this.externalUnitVisible;

    if (this.task !== undefined) {
      if (this.task.work) {
        if (this.task.work.contract === undefined) {
          this.uiService.showMessage(
            'Se ha producido un error en la carga de datos del contrato. ' +
            'Consulte con el administrador. ',
            'Aviso',
            'errorStyle'
          );
        }
        // if (model.dto.reloadProject === undefined || !model.dto.reloadProject) {
        model.dto = this.task.work.contract;

        // }
        model.ui.isAnulationMode = this.task.work.context.configurations.isAnulationMode.value;
        model.ui.isRectificationMode = this.task.work.context.configurations.isRectificationMode.value;
        model.ui.reservedEntityType1_2022_Aymad = this.reservedEntityType1_2022_Aymad;
        model.ui.outSourcingType1_2022_Aymad = this.outSourcingType1_2022_Aymad;
      }
      model.ui.isContextWork = true;
      if (model.dto.contractClassification && model.dto.contractClassification.accountingMotivation) {
        model.ui.accountingMotivation = model.dto.contractClassification.accountingMotivation;
      } else {
        model.ui.accountingMotivation = <MasterDataDTO>{
          identifier: '1<>TIPO_MOTIVACION_CONTABLE',
          description: 'Gasto'
        };
      }
      if (this.task.work) {
        model.dto.isProjectReplyca = this.task.work.contract && this.task.work.contract.isProjectReplyca;
        if (this.task.work.contract.division && this.task.work.contract.division.project &&
          this.task.work.contract.division.project.documentClass && this.task.work.contract.division.project.documentClass.identifier) {
          if (this.task.work.contract.division.project.documentClass.identifier === '00000') {
            model.ui.isAutomaticMode = true;
            model.ui.isVisibleConcesion = this.task.work.contract.euDirective !== undefined
              && this.task.work.contract.euDirective.identifier === '2014/23/EU<>DIRECTIVA_UE' ? true : false;
          }

        }

        if (model.dto && model.dto.division && model.dto.division.project && model.dto.division.project) {
          let procurementProjectAux: any;
          procurementProjectAux = model.dto.division.project;
          if (procurementProjectAux.exp_Instruccion_1_2022) {
            console.log('Es de 2022');
          }
        }

        // Configuración del modo edición para soporte
        if (this.task.work.contract && this.task.work.contract.context &&
          this.task.work.contract.context.configurations) {
          if (this.task.work.contract.context.configurations.isEditableSupport) {
            model.ui.isEditableSupport = this.task.work.contract.context.configurations.isEditableSupport.value;
          }
          if (this.task.work.contract.context.configurations.isRectificationMode) {
            if (this.task.work.contract.context.configurations.isEditableFinalEndDate) {
              model.ui.isEditableFinalEndDate = this.task.work.contract.context.configurations.isEditableFinalEndDate.value;
            } else {
              model.ui.isEditableFinalEndDate = true;
            }

          }

          if (this.task.work.contract.context.configurations.isEditableAwardAmount) {
            model.ui.isEditableAwardAmount = this.task.work.contract.context.configurations.isEditableAwardAmount.value;
          } else {
            model.ui.isEditableAwardAmount = true;
          }

        } else {
          model.ui.isEditableSupport = false;
        }
      }

    } else {
      model.ui.isContextWork = false;
      model.dto.isProjectReplyca = true;
      model.ui.isAnulationMode = false;
      model.ui.isRectificationMode = false;
      model.ui.isEditableSupport = false;
      model.ui.isEditableFinalEndDate = true;
      model.ui.isEditableAwardAmount = true;
    }
    if (model.dto.context && model.dto.context.configurations && model.dto.context.configurations.modeRegisterNumber
      && model.dto.context.configurations.modeRegisterNumber.value) {
      model.ui.modeRegisterNumber = model.dto.context.configurations.modeRegisterNumber.value;
      if (model.dto.context.configurations.modeRegisterNumber.value && model.dto.context.configurations.modeRegisterNumber.value === '2') {
        model.ui.isEditableRegisterNumber = true;
      } else {
        model.ui.isEditableRegisterNumber = false;
      }
    }

    if (model.dto.procurementProjectInfo) {
      if (model.dto.procurementProjectInfo.applicableLegislation) {
        model.ui.applicableLegislation = model.dto.procurementProjectInfo.applicableLegislation;
      }

      if (model.dto.procurementProjectInfo.type) {
        model.ui.type = model.dto.procurementProjectInfo.type;
        if (model.dto.procurementProjectInfo.type.properties) {
          model.ui.typeCodeMode = model.dto.procurementProjectInfo.type.properties['MODO'] !== undefined ?
            model.dto.procurementProjectInfo.type.properties['MODO'] : model.dto.procurementProjectInfo.type.identifier;
        }
      }

      if (model.dto.procurementProjectInfo && model.dto.procurementProjectInfo.classification
        && model.dto.procurementProjectInfo.classification.typeCode) {
        model.ui.typeCode = model.dto.procurementProjectInfo.classification.typeCode;
      }
      if (model.dto.procurementProjectInfo && model.dto.procurementProjectInfo.classification
        && model.dto.procurementProjectInfo.classification.urgencyCode) {
        model.ui.urgencyCode = model.dto.procurementProjectInfo.classification.urgencyCode;
      }

      model.ui.apportioned = model.dto.procurementProjectInfo.apportioned;
    } else {
      model.dto.procurementProjectInfo = new ContractProcurementProjectInformationDTO();
    }




    // Revisar a posteriori, de momento este campo siempre con valor no
    model.dto.procurementProjectInfo.allowIntOffers = false;

    // Si "Varios Org. Contratación" = NO -> Asignar valor de "Unidad de Contratación"
    if (model.dto.organizationalInfo) {
      model.dto.organizationalUnitAM = model.dto.organizationalInfo.contractingUnit;
    }

    if (model.dto.budget && model.dto.budget.cofinancedFile == null) {
      model.dto.budget.cofinancedFile = false;
    }

    if (model.dto.contractClassification) {
      if (model.dto.contractClassification.complementarySystem) {
        model.ui.complementarySystem = model.dto.contractClassification.complementarySystem;
      }
      if (model.dto.contractClassification.accountingMotivation) {
        model.ui.accountingMotivation = model.dto.contractClassification.accountingMotivation;
      }
    }

    if (ContractValidations.isCBAM(model.ui)) {
      model.ui.originalContractAM = model.dto.originalContractingSystemID;
    }

    if (ContractValidations.isCSDA(model.ui)) {
      model.ui.originalContractSDA = model.dto.originalContractingSystemID;
    }

    if (model.ui.type && model.ui.type.identifier === 'M<>PROCEDIMIENTOSCONTRA'
      || (model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO'
        && model.dto.secondBindigCB
        && (ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB)
          || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)))) {
      if (model.dto.plannedPeriod !== undefined) {
        model.ui.approvalAwardDateMinor = model.dto.plannedPeriod.approvalAwardDate;
      }
    } else {
      if (model.dto.plannedPeriod !== undefined) {
        model.ui.approvalAwardDate = model.dto.plannedPeriod.approvalAwardDate;
      }
    }

    let cliente = this.appConfig.getValue('cliente');
    if (cliente === 'AYMAD' && model.ui.complementarySystem && (model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO'
      || model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO')) {
      model.ui.companySelectedCBAM = new CompanyDTO();
      if (model.dto.company !== undefined) {
        if (model.dto.company.name === undefined) {
          // Si la empresa no tiene razon social, cogemos la del contrato.
          // Si no mostramos la razon social del contrato, el campo mostraría el identificador de RIL_EMPRESA.
          if (model.dto.originalContractingSystemID && model.dto.originalContractingSystemID.company
            && model.dto.originalContractingSystemID.company.name !== undefined) {
            model.dto.company.name = model.dto.originalContractingSystemID.company.name;
          }
        }
        model.ui.companySelectedCBAM = model.dto.company;

      } else {
        if (model.dto.originalContractingSystemID !== undefined) {
          model.ui.companySelectedCBAM = model.dto.originalContractingSystemID.company;
        }
      }
      if (model.dto.originalContractingSystemID === undefined) {
        model.dto.originalContractingSystemID = new ContractDTO();
        model.dto.originalContractingSystemID.registrationNumber = '';
      }
    } else {
      if (model.dto.company !== undefined) {
        if (model.ui.companySelected === undefined) {
          model.ui.companySelected = new ContractTendererDTO();
        }
        model.ui.companySelected.tenderer = model.dto.company;
        model.ui.companySelected.pyme = model.dto.contractClassification.pyme;
        model.ui.companySelected.pymeType = model.dto.contractClassification.pymeType;
      }
    }

    if (model.dto.procurementProjectInfo && model.dto.procurementProjectInfo.classification &&
      model.dto.procurementProjectInfo.classification.subTypeCode !== undefined) {
      model.ui.subTypeCodeGoods = model.dto.procurementProjectInfo.classification.subTypeCode;
    }

    if (model.dto.procurementProjectInfo && model.dto.procurementProjectInfo.classification &&
      model.dto.procurementProjectInfo.classification.subTypeCode !== undefined) {
      model.ui.subTypeCodeServices = model.dto.procurementProjectInfo.classification.subTypeCode;
    }

    // model.ui.isVisibleClassificationCompany = this.isVisibleClassificationCompany(this.task.work.contract);
    // model.ui.isVisibleClassificationCompany = this.isVisibleClassificationCompany(model.dto);
    model.ui.isSettlementMode = this.isSettlementMode(model.dto)
    let i = 0;
    let contractLotsCpvs: Array<ContractLotCPVDTO> = [];
    let contractTendererLot: Array<ContractTendererLotDTO> = [];
    let contractTendererLotInvited: Array<ContractTendererLotDTO> = [];
    let contractClassificationSchemaLot: Array<ClassificationSchemaLotDTO> = [];
    let contractSpecialConditionsDTOLot: Array<ContractSpecialConditionsLotDTO> = [];
    let warrantiesDTOLot: Array<WarrantyLotDTO> = [];
    let contractAwardCriteriaDTOLot: Array<ContractAwardCriteriaLotDTO> = [];
    if (model.dto.contractLots !== undefined) {
      //Creamos esta variable, copia de lotes, para no tocar el contenido del dto
      //En esta parte se están creando las tablas desglosadas por lotes, aplanando los lotes,
      //ya que las tablas de angular no permite pintar listas de listas, se ha creado asociado al DTO del contract
      //Unas listas que servirán para pintar en las tablas donde ya está aplando el lote y los datos correspondienes
      //de cada tabla. En el modelToDTO se debe hacer la conversión a la inversa, para que la información vaya correctamente
      //cargada en el dto.contractoLots
      model.ui.desgloseLotes = lodash.cloneDeep(model.dto.contractLots);
      //model.ui.contractLots = model.dto.contractLots;
      model.ui.desgloseLotes.forEach(contractLot => {

        //let cloneLotContractLot = lodash.cloneDeep(contractLot.lot);


        //Tabla desglose lotes cpv
        if (contractLot.cpvs !== undefined) {

          contractLot.cpvs.forEach(cpv => {
            let contractLotCPV = lodash.cloneDeep(contractLot);
            let lotCpv = new ContractLotCPVDTO();
            lotCpv.contractLot = new ContractLotDTO();
            lotCpv.contractLot.lot = contractLotCPV.lot;
            lotCpv.contractCpv = cpv;
            contractLotsCpvs.push(lotCpv);
          });
        }
        // Tabla desglose lotes condicones especiales de ejecución
        if (contractLot.specialExecutionConditions !== undefined) {

          contractLot.specialExecutionConditions.forEach(specialCondition => {
            let contractLotSpecialExecution = lodash.cloneDeep(contractLot);
            let specialConditionLot = new ContractSpecialConditionsLotDTO();
            specialConditionLot.specialCondition = specialCondition;
            specialConditionLot.contractLot = new ContractLotDTO();
            specialConditionLot.contractLot.lot = contractLotSpecialExecution.lot;
            contractSpecialConditionsDTOLot.push(specialConditionLot);
          });
        }
        //Tabla desglose lotes garantias
        if (contractLot.warranty && contractLot.warranty.warranties !== undefined) {

          contractLot.warranty.warranties.forEach(warranty => {
            let contractLotwarranty = lodash.cloneDeep(contractLot);
            let warrantyLot = new WarrantyLotDTO();
            warrantyLot.warranty = warranty;
            warrantyLot.contractLot = new ContractLotDTO();
            warrantyLot.contractLot.lot = contractLotwarranty.lot;
            warrantiesDTOLot.push(warrantyLot);
          });
        }
        //Tabla desglose lotes licitadores
        if (contractLot.contractTenderers !== undefined) {

          contractLot.contractTenderers.forEach(tenderer => {
            let contractLotTenderer = lodash.cloneDeep(contractLot);
            let tendererLot = new ContractTendererLotDTO();
            tendererLot.tenderer = tenderer.tenderer;
            tendererLot.pyme = tenderer.pyme;
            tendererLot.pymeType = tenderer.pymeType;
            tendererLot.contractLot = new ContractLotDTO();
            tendererLot.contractLot.lot = contractLotTenderer.lot;
            contractTendererLot.push(tendererLot);
          });
        }
        //Tabla desglose lotes licitadores invitados
        if (contractLot.contractTenderersInvited !== undefined) {

          contractLot.contractTenderersInvited.forEach(tenderer => {
            let contractLotTendererInvited = lodash.cloneDeep(contractLot);
            let tendererLot = new ContractTendererLotDTO();
            tendererLot.tenderer = tenderer.tenderer;
            tendererLot.pyme = tenderer.pyme;
            tendererLot.pymeType = tenderer.pymeType;
            tendererLot.contractLot = new ContractLotDTO();
            tendererLot.contractLot.lot = contractLotTendererInvited.lot;
            contractTendererLotInvited.push(tendererLot);
          });
        }
        //Tabla desglose lotes clasificación
        if (contractLot.classificationSchema !== undefined) {

          contractLot.classificationSchema.forEach(classification => {
            let contractLotClassificationSchema = lodash.cloneDeep(contractLot);
            let clasificationLot = new ClassificationSchemaLotDTO();
            clasificationLot.classification = classification;
            clasificationLot.contractLot = new ContractLotDTO();
            clasificationLot.contractLot.lot = contractLotClassificationSchema.lot;
            contractClassificationSchemaLot.push(clasificationLot);
          });
        }

        //Tabla desglose lotes criterios de adjudicación
        if (contractLot.contractAwardCriteria !== undefined) {

          contractLot.contractAwardCriteria.forEach(awardCriteria => {
            let contractLotAwardCriteria = lodash.cloneDeep(contractLot);
            let contractAwardCriteria = new ContractAwardCriteriaLotDTO();
            contractAwardCriteria.awardCriteria = awardCriteria;
            contractAwardCriteria.contractLot = new ContractLotDTO();
            contractAwardCriteria.contractLot.lot = contractLotAwardCriteria.lot;
            contractAwardCriteriaDTOLot.push(contractAwardCriteria);
          });
        }
      });

    }
    model.dto.contractTendererLot = contractTendererLot;
    model.dto.contractTendererLotInvited = contractTendererLotInvited;
    model.dto.contractClassificationSchemaLot = contractClassificationSchemaLot;
    model.dto.contractLotsCpvs = contractLotsCpvs;
    model.dto.contractSpecialConditionsLot = contractSpecialConditionsDTOLot;
    model.dto.warrantyLot = warrantiesDTOLot;
    model.dto.contractAwardCriteriaLot = contractAwardCriteriaDTOLot;
    model.ui.listaLotes = this.getListaLotes(model);

    model.ui.homologationSystem = model.dto.homologationSystem;


    if (model.dto && model.dto.context && model.dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
      model.ui.activeTemporayPeriodOrganizationalChange =
        model.dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
      if (!model.ui.activeTemporayPeriodOrganizationalChange && model.dto.previousOrganizationalUnitRegistration !== undefined) {
        // No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
        model.ui.enabledPreviousOrganizationalUnitRegistration = false;
      }
    }

    model.ui.selectedOrganizationalInfo = model.dto.organizationalInfo;


    // MATERIAL SOLICITADO CONTRATO

    if (dto.contractLots) {
      this.showRequestedMaterialLotes = true;
      model['ui']['lotesDes'] = dto.contractLots.map((tl => { return tl.lot.lotId }))
      model['ui']['lotesDes'] = '' + model['ui']['lotesDes'] + '';

      model['ui']['lotNumberDes'] = dto.contractLots.map((tl => { return tl.lot.lotNumber }))
      model['ui']['lotNumberDes'] = '' + model['ui']['lotNumberDes'] + '';
    }



    let modelObs: Observable<ContractModel>;
    modelObs = of(model);
    return modelObs;
  }

  private getListaLotes(model: ContractModel): any[] {

    let elements = [];

    if (model.dto.contractLots !== undefined) {
      model.dto.contractLots.forEach(item => {
        if (item.lot !== undefined) {
          elements.push(this.reduceLot(item));
        }
      });

      return elements;
    }
  }

  private reduceLot(contractLot: ContractLotDTO) {
    // Se limpia el resto de datos para evitar referencias circulares
    let _reducedLot = {
      'value': contractLot.lot.lotNumber,
      'label': contractLot.lot.description

    };

    return _reducedLot;
  }



  exitProject() {
    this.subscribe(this.plycaService.query<ContractDTO>(
      this.configuration.CONTRACTS_SERVICE_URL,
      {
        contractFolderId: this.model.dto.division.project.contractFolderId
      }
    ), (result: PaginationDTO<ContractDTO>) => {

      if (result !== null && result.content) {
        let projectEntity = result.content[0];
        if (!projectEntity.procurementProjectInfo.apportioned) {
          this.uiService.showMessage(
            'Se ha encontrado un contrato ya registrado con el mismo número de expediente ' +
            'y esta marcado como contrato sin lotes. ' +
            'Para poder crear un contrato asociado a dicho número de expediente ' +
            'debería marcarse el contrato original como contrato con lotes.',
            'Aviso',
            'errorStyle'
          );
        } else {
          this.uiService.showMessage(
            'Se ha encontrado un contrato ya registrado con el mismo número de expediente ' +
            'Se puede arrastrar la información del expediente del contrato a través del botón de Precarga Expediente. ',
            'Aviso',
            'errorStyle'
          );
        }

      }
    });
  }

  getDeadlines() {
    let cliente = this.appConfig.getValue('cliente');
    if (this.model.dto.division.project.contractFolderId === undefined
      && this.model.dto.division.project.documentClass.identifier === '00000') {
      this.uiService.showMessage(
        'Indique en el contrato el número de expediente a sobre el que realizar el cálculo.',
        'Aviso',
        'errorStyle'
      );
    } else if (this.model.dto.plannedPeriod.startDate === undefined) {
      this.uiService.showMessage(
        'Debe indicarse una fecha de inicio del contrato para realizar el cálculo del plazo.',
        'Aviso',
        'errorStyle'
      );
    } else if (this.model.dto.plannedPeriod.endDate === undefined && 'AYMAD' !== cliente) {

      this.uiService.showMessage(
        'Debe indicarse una fecha de fin del contrato para realizar el cálculo del plazo',
        'Aviso',
        'errorStyle'
      );

    } else if (this.model.dto.plannedPeriod.endDate !== undefined &&
      this.model.dto.plannedPeriod.startDate.getTime() > this.model.dto.plannedPeriod.endDate.getTime()) {
      this.uiService.showMessage(
        'La fecha de inicio indicada no puede ser superior a la fecha de fin.',
        'Aviso',
        'errorStyle'
      );
    } else {
      this.subscribe(this.plycaService.getDeadLines(this.model.dto.plannedPeriod,
        this.model.dto.division.project.contractFolderId, this.model.dto.division
      ), ((result2: ContractPlannedPeriodDTO) => {
        this.model.dto.plannedPeriod.durationMonth = result2.durationMonth;
        this.model.dto.plannedPeriod.endDate = result2.endDate;
      }));
    }

  }

  // Metódo para recargar datos del expediente de contratación cuando este se subsana.
  /*reloadProject() {
    this.uiService.showConfirmMessage({
      message: 'Se va a proceder a restaurar la información del expediente de contratación. ' +
        '¿Desea continuar?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscribe(this.plycaService.reloadInfoProject(this.model.dto.identifier
        ),


          ((result: ContractDTO) => {
            // this.model.dto = result2;
            this.subscribe(this.dtoToModel(result), ((model) => {
              this.model.dto = model.dto;
              this.model.ui = model.ui;
              this.projectLoaded = true;
            }));

          }));

        console.log('Precargando informacion...');
      },
      reject: () => {
        this.waitService.cancelWaiting();
        console.log('No hace nada...');
      }
    });
  }*/



  loadProject() {
    if (this.model.dto.division.project.contractFolderId === undefined) {
      this.uiService.showMessage(
        'Indique en el contrato el número de expediente a precargar.',
        'Aviso',
        'errorStyle'
      );
    } else {
      let url =
        this.configuration.CONTRACTS_SERVICE_URL +
        '?contractFolderId=' +
        this.model.dto.division.project.contractFolderId.trim()
      '&expand=expansionSet:WEB_CLIENT';
      this.waitService.startWaiting();
      this.subscribe(
        this.plycaService.query<ContractDTO>(url
        ), ((result: PaginationDTO<ContractDTO>) => {

          if (result !== null && result.content) {
            let projectEntity = result.content[0];
            if (!projectEntity.procurementProjectInfo.apportioned
              && projectEntity.contractClassification.complementarySystem &&
              ((projectEntity.contractClassification.complementarySystem.identifier !== 'AM<>SISTCOMPLEMENTARIO')
                || (projectEntity.contractClassification.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO'
                  && projectEntity.numberAwards <= 1))) {
              this.waitService.cancelWaiting();
              this.uiService.showMessage(
                'Se ha encontrado un expediente ya registrado con el mismo número de expediente ' +
                'y esta marcado como expediente sin lotes. ' +
                'Para poder crear un contrato asociado a dicho expediente debería marcarse como expediente con lotes.',
                'Aviso',
                'errorStyle'
              );
            } else {
              this.waitService.cancelWaiting();
              this.uiService.showConfirmMessage({
                message: 'Se ha encontrado un expediente ya registrado con el mismo número de expediente. ' +
                  '¿Desea precargar la información relacionada?',
                header: 'Confirmacion',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                  this.waitService.startWaiting();
                  let contratLotIni = undefined;
                  let parent = undefined;
                  // let contractLostOriginal = this.model.dto.contractLots;
                  if (this.model.dto.contractLots && this.model.dto.contractLots.length > 0) {
                    contratLotIni = this.model.dto.contractLots.shift();
                    parent = contratLotIni._parent;
                    // loteNumber = contratLot.lot.lotNumber
                  }
                  this.subscribe(this.plycaService.getLastContractAproved(this.model.dto.division.project.contractFolderId, contratLotIni
                  ),
                    ((result2: ContractDTO) => {
                      this.waitService.cancelWaiting();
                      // this.model.dto = result2;
                      this.subscribe(this.dtoToModel(result2), ((model) => {
                        this.model.dto = model.dto;
                        this.model.ui = model.ui;
                        if (this.model.dto.contractLots) {
                          this.model.dto.contractLots.forEach(contractLot => {
                            contractLot['_parent'] = parent;
                            // contractLot.lot = contratLotIni.lot;
                          });
                        }

                      }));

                    }));
                  this.projectLoaded = true;
                  console.log('Precargando informacion...');
                },
                reject: () => {
                  this.waitService.cancelWaiting();
                  console.log('No hace nada...');
                }
              });
            }
          } else {
            this.waitService.cancelWaiting();
            this.uiService.showMessage(
              'No existe ninguna inscripción para el expediente indicado.',
              'Aviso',
              'errorStyle'
            );

          }
        }
      ));

    }
  }

  modelToDTO(model: ContractModel): ContractDTO {
    let isLote0 = false;
    if (model.dto.contractLots === undefined) {
      //Para contratos sin lotes, la tabla de lotes, que está referenciada al dto.contractLots, no se visualiza
      //Por eso estamos cargando lo que teníamos copiado en el ui.
      model.dto.contractLots = model.ui.desgloseLotes;
      isLote0 = true;
    }

    model.dto = JSON.parse(
      JSON.stringify(model.dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    if (model.dto.plannedPeriod !== undefined) {
      delete model.dto.plannedPeriod['initialExecutionPeriod'];
      // delete model.dto.plannedPeriod['finalExecutionPeriod'];
    }

    // Convertir los ui a dto hasta que se revierta el cambio de los campos en espejo
    if (model.ui.applicableLegislation) {
      model.dto.procurementProjectInfo.applicableLegislation = model.ui.applicableLegislation;
    } else {
      model.dto.procurementProjectInfo.applicableLegislation = undefined;
    }

    if (model.ui.type) {
      model.dto.procurementProjectInfo.type = model.ui.type;
    } else {
      // En los contratos de emergencia el procedimiento no se ve, en ese caso debe comportarse como un abierto.
      if (model.ui.urgencyCode &&
        model.ui.urgencyCode.identifier === 'E<>CLASEEXPTE') {
        model.dto.procurementProjectInfo.type = <MasterDataDTO>{
          identifier: 'A<>PROCEDIMIENTOSCONTRA',
          description: 'Abierto'
        };
      } else {
        model.dto.procurementProjectInfo.type = undefined;
      }
    }

    if (!model.dto.plannedPeriod) {
      model.dto.plannedPeriod = new ContractPlannedPeriodDTO();
    }
    if (model.ui.type && model.ui.type.identifier === 'M<>PROCEDIMIENTOSCONTRA'
      || (model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO'
        && (model.dto.secondBindigCB && ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB) ||
          model.dto.secondBindigCB && ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)))) {
      model.dto.plannedPeriod.approvalAwardDate = model.ui.approvalAwardDateMinor;
    } else {

      model.dto.plannedPeriod.approvalAwardDate = model.ui.approvalAwardDate;
    }

    if (!model.dto.procurementProjectInfo) {
      model.dto.procurementProjectInfo = new ContractProcurementProjectInformationDTO();
    }
    if (!model.dto.procurementProjectInfo.classification) {
      model.dto.procurementProjectInfo.classification = new ProcurementProjectClassificationDTO();
    }

    if (model.ui.typeCode) {
      model.dto.procurementProjectInfo.classification.typeCode = model.ui.typeCode;
    } else {
      model.dto.procurementProjectInfo.classification.typeCode = undefined;
    }

    if (model.ui.homologationSystem) {
      model.dto.homologationSystem = model.ui.homologationSystem;
    } else {
      model.dto.homologationSystem = undefined;
    }

    if (model.ui.urgencyCode) {
      model.dto.procurementProjectInfo.classification.urgencyCode = model.ui.urgencyCode;
    } else {
      model.dto.procurementProjectInfo.classification.urgencyCode = undefined;
    }

    if (model.ui.apportioned) {
      model.dto.procurementProjectInfo.apportioned = model.ui.apportioned;
    } else {
      model.dto.procurementProjectInfo.apportioned = false;
    }

    if (!model.dto.contractClassification) {
      model.dto.contractClassification = new ContractClassificationDTO();
    }

    if (model.ui.complementarySystem) {
      model.dto.contractClassification.complementarySystem = model.ui.complementarySystem;
    } else {
      model.dto.contractClassification.complementarySystem = undefined;
    }
    if (model.ui.accountingMotivation) {
      model.dto.contractClassification.accountingMotivation = model.ui.accountingMotivation;
    } else {
      model.dto.contractClassification.accountingMotivation = undefined;
    }
    let cliente = this.appConfig.getValue('cliente');
    if (cliente === 'AYMAD' && model.ui.complementarySystem && (model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO'
      || model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO')) {
      model.dto.company = this.model.ui.companySelectedCBAM;
    } else {
      if (this.model.ui.companySelected) {
        model.dto.company = this.model.ui.companySelected.tenderer;
        if (model.dto.contractClassification.pyme === undefined) {
          model.dto.contractClassification.pyme = this.model.ui.companySelected.pyme;
        }
      }
    }

    // Redondeamos el calculo de los importes totales
    if (model.dto.budget.awardAmount && model.dto.budget.awardAmount.totalAmount) {
      model.dto.budget.awardAmount.totalAmount = this.roundDecimals(model.dto.budget.awardAmount.totalAmount, 2);
    }
    if (model.dto.budget.tenderingAmount && model.dto.budget.tenderingAmount.totalAmount) {
      model.dto.budget.tenderingAmount.totalAmount = this.roundDecimals(model.dto.budget.tenderingAmount.totalAmount, 2);
    }
    if (model.dto.budget.awardCancellationPercentage) {
      model.dto.budget.awardCancellationPercentage = this.roundDecimals(model.dto.budget.awardCancellationPercentage, 2);
    }
    if (model.dto.budget.budgetAccountLines) {
      model.dto.budget.budgetAccountLines.forEach(budget => {
        if (budget.budget && budget.budget.totalAmount) {
          budget.budget.totalAmount = this.roundDecimals(budget.budget.totalAmount, 2);
        }
      });
    }
    if (model.dto.budget.budgetAccountLinesContract) {
      model.dto.budget.budgetAccountLinesContract.forEach(budget => {
        if (budget.budget && budget.budget.totalAmount) {
          budget.budget.totalAmount = this.roundDecimals(budget.budget.totalAmount, 2);
        }
      });
    }
    if (model.dto.contractLots === undefined) {
      let listaLotes: Array<ContractLotDTO> = [];
      let lote0 = new ContractLotDTO();
      let lot = new LotDTO();
      lot.lotId = 0;
      lot.lotNumber = 0;
      lote0.lot = lot;
      listaLotes[0] = lote0;
      model.dto.contractLots = listaLotes;
      isLote0 = true;
    }

    // Metodos para asociar los datos desglosados por lotes
    model.dto = this.setSpecialConditionsToLot(model.dto, isLote0);
    model.dto = this.setWarrantyToLot(model.dto, isLote0);
    model.dto = this.setAwardCriteriaToLot(model.dto, isLote0);
    model.dto = this.setContractClassfication(model.dto, isLote0);
    model.dto = this.setTenderToLot(model.dto, isLote0);
    model.dto = this.setTenderInvitedToLot(model.dto, isLote0);


    if (model.dto.contractLots !== undefined) {
      model.dto.contractLots.forEach(contractLot => {
        let cpvAux: Array<ContractCPVDTO> = [];
        let i = 0;
        if (isLote0 && model.dto.totalLots !== undefined) {
          cpvAux = model.dto.totalLots.cpvs;
        } else {
          if (model.dto.contractLotsCpvs !== undefined) {
            model.dto.contractLotsCpvs.forEach(cpvLot => {
              if (cpvLot.contractLot && contractLot.lot.lotNumber === cpvLot.contractLot.lot.lotNumber) {
                cpvAux[i] = new ContractCPVDTO();
                cpvAux[i].cpv = cpvLot.contractCpv.cpv;
                i++;
              } else {
                if (model.dto.contractLots.length === 1) {
                  cpvAux[i] = new ContractCPVDTO();
                  if (cpvLot.contractCpv) {
                    cpvAux[i].cpv = cpvLot.contractCpv.cpv;
                  }
                  i++;
                }

              }
            });
            contractLot.cpvs = cpvAux;
          }
        }

      });
    }
    if (model.dto.procurementProjectInfo !== undefined && model.dto.procurementProjectInfo.classification !== undefined
      && model.dto.procurementProjectInfo.classification.typeCode !== undefined
      && (model.dto.procurementProjectInfo.classification.typeCode.identifier === '02<>TIPOEXPTE'
        || model.dto.procurementProjectInfo.classification.typeCode.identifier === '06<>TIPOEXPTE')) {

      if (model.ui.subTypeCodeGoods !== undefined) {
        model.dto.procurementProjectInfo.classification.subTypeCode = model.ui.subTypeCodeGoods;
      } else {
        model.dto.procurementProjectInfo.classification.subTypeCode = undefined;
      }
    }
    if (model.dto.procurementProjectInfo !== undefined && model.dto.procurementProjectInfo.classification !== undefined
      && model.dto.procurementProjectInfo.classification.typeCode !== undefined
      && model.dto.procurementProjectInfo.classification.typeCode.identifier === '04<>TIPOEXPTE') {
      if (model.ui.subTypeCodeServices !== undefined) {
        model.dto.procurementProjectInfo.classification.subTypeCode = model.ui.subTypeCodeServices;
      } else {
        model.dto.procurementProjectInfo.classification.subTypeCode = undefined;
      }
    }

    if (ContractValidations.isCBAM(model.ui)) {
      model.dto.originalContractingSystemID = model.ui.originalContractAM;
    }

    if (ContractValidations.isCSDA(model.ui)) {
      model.dto.originalContractingSystemID = model.ui.originalContractSDA;
    }

    if (this.task) {
      this.task.work.contract = model.dto;
      model.dto.isProjectReplyca = this.task.work.contract.isProjectReplyca;
      model.dto.manualRegistration = false;
    } else {
      model.dto.manualRegistration = true;
      model.dto.isProjectReplyca = true;
    }
    return model.dto;
  }

  // Metodo que sirve para asociar los licitadores invitados a la estructura de lotes de los contratos
  public setTenderInvitedToLot(dto: ContractDTO, isLote0: boolean) {
    if (dto.contractTendererLotInvited !== undefined && dto.contractTendererLotInvited.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          let contractTendererAux: Array<ContractTendererDTO> = [];
          let i = 0;
          dto.contractTendererLotInvited.forEach(tenderer => {
            if (isLote0 || contractLot.lot !== undefined && tenderer.contractLot && tenderer.contractLot.lot !== undefined
              && contractLot.lot.lotNumber === tenderer.contractLot.lot.lotNumber) {
              contractTendererAux[i] = new ContractTendererDTO();
              contractTendererAux[i].tenderer = tenderer.tenderer;
              contractTendererAux[i].pyme = tenderer.pyme;
              i++;
            } else if (dto.contractLots.length === 1) {
              contractTendererAux[i] = new ContractTendererDTO();
              contractTendererAux[i].tenderer = tenderer.tenderer;
              contractTendererAux[i].pyme = tenderer.pyme;
              i++;
            }
          });
          contractLot.contractTenderersInvited = contractTendererAux;
        });
      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          contractLot.contractTenderersInvited = undefined;
        });
      }
    }
    return dto;
  }

  // Metodo que sirve para asociar los licitadores a la estructura de lotes de los contratos
  public setTenderToLot(dto: ContractDTO, isLote0: boolean) {
    if (dto.contractTendererLot !== undefined && dto.contractTendererLot.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          let contractTendererAux: Array<ContractTendererDTO> = [];
          let i = 0;
          dto.contractTendererLot.forEach(tenderer => {
            if (isLote0 || contractLot.lot !== undefined && tenderer.contractLot && tenderer.contractLot.lot !== undefined
              && contractLot.lot.lotNumber === tenderer.contractLot.lot.lotNumber) {
              contractTendererAux[i] = new ContractTendererDTO();
              contractTendererAux[i].tenderer = tenderer.tenderer;
              contractTendererAux[i].pyme = tenderer.pyme;
              i++;
            } else if (dto.contractLots.length === 1) {
              contractTendererAux[i] = new ContractTendererDTO();
              contractTendererAux[i].tenderer = tenderer.tenderer;
              contractTendererAux[i].pyme = tenderer.pyme;
              i++;
            }
          });
          contractLot.contractTenderers = contractTendererAux;
        });
      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          contractLot.contractTenderers = undefined;
        });
      }
    }
    return dto;
  }
  // Metodo que sirve para asociar la clasificación del contrato a la estructura de lotes de los contratos
  public setContractClassfication(dto: ContractDTO, isLote0: boolean) {
    if (dto.contractClassificationSchemaLot !== undefined && dto.contractClassificationSchemaLot.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          let classificationSchemaAux: Array<ClassificationSchemaDTO> = [];
          let i = 0;
          dto.contractClassificationSchemaLot.forEach(classification => {
            if ((isLote0 && classification.classification !== undefined) || (classification.contractLot
              && contractLot.lot !== undefined && classification.classification !== undefined
              && contractLot.lot.lotNumber === classification.contractLot.lot.lotNumber)) {
              classificationSchemaAux[i] = classification.classification;
              i++;
            } else if (dto.contractLots.length === 1) {
              classificationSchemaAux[i] = new ClassificationSchemaDTO();
              if (classification.classification !== undefined) {
                classificationSchemaAux[i] = classification.classification;
              }
              i++;
            }
          });

          contractLot.classificationSchema = classificationSchemaAux;

        });
      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          contractLot.classificationSchema = undefined;
        });
      }
    }
    return dto;
  }
  // Metodo que sirve para asociar los criterios de adjudicación a la estructura de lotes de los contratos
  public setAwardCriteriaToLot(dto: ContractDTO, isLote0: boolean) {
    if (dto.contractAwardCriteriaLot !== undefined && dto.contractAwardCriteriaLot.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          if (dto.contractAwardCriteriaLot.length === 0) {
            contractLot.contractAwardCriteria = undefined;
          } else {
            let awardCriteriaAux: Array<ContractAwardCriteriaDTO> = [];
            let i = 0;
            dto.contractAwardCriteriaLot.forEach(awardCriteria => {
              if (isLote0 || (awardCriteria.contractLot && contractLot.lot.lotNumber === awardCriteria.contractLot.lot.lotNumber)) {
                if (awardCriteria.awardCriteria !== undefined) {
                  awardCriteriaAux[i] = awardCriteria.awardCriteria;
                } else {
                  awardCriteriaAux[i] = new ContractAwardCriteriaDTO();
                }

                i++;
              } else if (dto.contractLots.length === 1) {
                awardCriteriaAux[i] = new ContractAwardCriteriaDTO();
                awardCriteriaAux[i] = awardCriteria.awardCriteria;
                i++;
              }
            });
            if (awardCriteriaAux != null && awardCriteriaAux.length > 0) {
              contractLot.contractAwardCriteria = awardCriteriaAux;
            }
          }
        });

      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          contractLot.contractAwardCriteria = undefined;
        });
      }
    }
    return dto;
  }
  // Metodo que sirve para asociar las condiciones especiales de ejecución a la estructura de lotes de los contratos
  public setSpecialConditionsToLot(dto: ContractDTO, isLote0: boolean) {
    if (dto.contractSpecialConditionsLot !== undefined && dto.contractSpecialConditionsLot.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          let specialConditionAux: Array<ContractSpecialConditionsDTO> = [];
          let i = 0;
          dto.contractSpecialConditionsLot.forEach(specialCondition => {

            if (isLote0 || (specialCondition.contractLot && contractLot.lot.lotNumber === specialCondition.contractLot.lot.lotNumber)) {
              if (specialCondition.specialCondition !== undefined) {
                specialConditionAux[i] = new ContractSpecialConditionsDTO();
                specialConditionAux[i] = specialCondition.specialCondition;
                i++;
              }
            } else if (dto.contractLots.length === 1) {
              specialConditionAux[i] = new ContractSpecialConditionsDTO();
              specialConditionAux[i] = specialCondition.specialCondition;
              i++;
            }

          });
          contractLot.specialExecutionConditions = specialConditionAux;
        });
      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          contractLot.specialExecutionConditions = undefined;
        });
      }
    }
    return dto;
  }

  // Metodo que sirve para asociar las garantías a la estructura de lotes de los contratos
  public setWarrantyToLot(dto: ContractDTO, isLote0: boolean) {
    if (dto.warrantyLot !== undefined && dto.warrantyLot.length > 0) {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          let warrantyLotAux: Array<WarrantyDTO> = [];
          // let i = 0;
          dto.warrantyLot.forEach(warranty => {

            if (isLote0 || (warranty.contractLot && contractLot.lot.lotNumber === warranty.contractLot.lot.lotNumber)) {
              if (warranty.warranty !== undefined) {
                warrantyLotAux.push(warranty.warranty);
              }
              /*else {
                warrantyLotAux[i] = new WarrantyDTO();
              }
              i++;*/
            } else if (dto.contractLots.length === 1) {
              warrantyLotAux.push(warranty.warranty);
            }

          });

          if (!contractLot.warranty) {
            contractLot.warranty = new ContractWarrantyDTO();
          }
          contractLot.warranty.warranties = warrantyLotAux;

        });
      }
    } else {
      if (dto.contractLots !== undefined) {
        dto.contractLots.forEach(contractLot => {
          if (contractLot.warranty) {
            contractLot.warranty.warranties = undefined;
          }
        });
      }
    }
    return dto;
  }

  getTitle(model: ContractDTO): string {
    if (model) {
      return model.identifier + ' - ';
    } else {
      return 'Nuevo grupo';
    }
  }

  // getProjectId(): string {
  //   return this.model.dto.project.identifier;
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Ficha registro de contrato';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getValidationContext() {
    let nameValidation = '';
    if (!this.model.ui.isAutomaticMode) {
      if (this.model.dto && this.model.dto.context && this.model.dto.context.configurations &&
        this.model.dto.context.configurations.validateReplyca) {
        nameValidation = this.model.dto.context.configurations.validateReplyca.value;
      }
    } else {
      if (this.model.dto && this.model.dto.context && this.model.dto.context.configurations &&
        this.model.dto.context.configurations.validateCont) {
        nameValidation = this.model.dto.context.configurations.validateCont.value;
      }
    }
    let validationCtx = this.model.dto.identifier ? (nameValidation + 'Update') : (nameValidation + 'Insert');
    return validationCtx;
  }

  validateContract() {
    let dto = this.modelToDTO(lodash.cloneDeep(this.model));
    this.subscribe(this.validateContext(true, dto, this.getValidationContext()),
      (result => {
        // if (result.result === ResultTypeDTO.ERROR || result.result === ResultTypeDTO.WARNING) {
        //   this.formPlycaRef.manageFormException(result);
        // } else
        if (result.result === ResultTypeDTO.OK) {
          this.uiService.showMessage(
            'Se ha verificado correctamente.',
            'Aviso',
            'errorStyle'
          );
        }
      }))
  }

  initHeaderActions() {
    let cliente = this.appConfig.getValue('cliente');
    if (this.appConfig.getValue('requested.material.management')) {
      this.subscribe(this.headerActionsService
        .addAction(
          'ProcurementProject.requestedMaterial.title',
          'fas fa-pencil-alt',
          'btn-primary',
          true,
          this.model.dto?.registrationNumber !== undefined
        ),
        () => {

          this.openMaterialEditor(this.model.dto)

        });
    }
    this.subscribe(this.headerActionsService
      .addAction('Contracts.Header.ReloadBudgetAccountLine', 'fas fa-sync', 'btn-primary',
        'MUNIV' === cliente && this.model.ui.isAutomaticMode)
      , (() => {
        this.reloadBudgetAccountLine();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Contracts.Header.CopyContract', 'far fa-copy', 'btn-primary',
        'AYMAD' === cliente && !this.model.ui.isAutomaticMode && (this.task === undefined
          || (this.task && this.task.work && this.task.work.contract && this.task.work.contract.identifier === undefined)))
      , (() => {
        this.loadProject();
      }));
    /*this.subscribe(this.headerActionsService
      .addAction('Recargar Expediente', 'fas fa-sync-alt', 'btn-primary',
        this.model.ui.isAutomaticMode && this.task && this.task.work && this.task.work.contract && this.task.work.contract.identifier)
      , (() => {
        this.reloadProject();
      }));*/
    // Sólo visible en automáticas, no visible para menores.
    this.subscribe(this.headerActionsService
      .addAction('Contracts.Header.CalculateEndDate', 'fas fa-calendar-check', 'btn-primary',
        ('AYMAD' === cliente && this.task && this.task.work && this.task.work.contract && this.task.work.contract.procurementProjectInfo
          && this.task.work.contract.procurementProjectInfo.type
          && this.task.work.contract.procurementProjectInfo.type.identifier !== 'M<>PROCEDIMIENTOSCONTRA'
          && this.task.work.contract.division
          && this.task.work.contract.division.project
          && this.task.work.contract.division.project.documentClass
          && this.task.work.contract.division.project.documentClass.identifier === '00000'
          && this.task.work.contract.context
          && this.task.work.contract.context.configurations
          && this.task.work.contract.context.configurations.isEditableFinalEndDate
          && this.task.work.contract.context.configurations.isEditableFinalEndDate.value === true)
        || ('AYMAD' !== cliente))
      , (() => {
        this.getDeadlines();
      }));

    this.subscribe(this.headerActionsService
      .addAction('Contracts.Header.verify', 'fas fa-check', 'btn-primary', true)
      , (() => {
        this.validateContract();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Contracts.Header.save', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          let dto = this.modelToDTO(lodash.cloneDeep(this.model));
          // let dto = this.modelToDTO(this.model);
          if (this.task !== undefined) {
            this.cleanWorkContract();
            this.subscribe(this.saveIfValidContext(true, dto, this.getValidationContext()),
              _model => {
                if (_model.work && _model.work.contract && _model.work.contract.identifier) {
                  this.model.dto.identifier = _model.work.contract.identifier;
                  this.model.dto.registrationNumber = _model.work.contract.registrationNumber;
                }
              });
          } else {
            this.waitService.startWaiting();

            this.subscribe(this.validateContext(false, dto, this.getValidationContext())
              , result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                  this.uiService.showConfirmMessage({
                    message: this.translate.instant('Contracts.Header.confirmSave'),
                    header: this.translate.instant('General.confirm.text'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                      console.log('Grabando contrato...');
                      this.waitService.startWaiting();
                      this.subscribe(this.saveContext(false, dto, this.getValidationContext()),
                        _model => {
                          if (_model) {
                            this.goToDossierInfo(_model);
                          } else {
                            this.goToDossierInfo(this.model.dto);
                          }
                        });

                    },
                    reject: () => {
                      console.log('No hace nada...');
                    }

                  });
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.saveContext(false, dto, this.getValidationContext()), _model => {
                    this.waitService.startWaiting();
                    if (_model) {
                      this.goToDossierInfo(_model);
                    } else {
                      this.goToDossierInfo(this.model.dto);
                    }
                  });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
            )
          }
        }));

    this.headerActionsService.addDivider();
    this.addBack();
  }

  showConfirmMessage(_contract: ContractDTO) {
    this.uiService.showConfirmMessage({
      message: '¿Desea registrar el contrato?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.goToDossierInfo(_contract);
        console.log('Saliendo...');
      },
      reject: () => {
        this.waitService.cancelWaiting();
        console.log('No hace nada...');
      }
    });
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        if (this.task !== undefined) {
          this.cleanWorkContract();
        }
        this.salir();
      }));
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.functions.push({
      identifier: 'openCPVSelector',
      fn: this.openCPVSelector.bind(this)
    });
    formConfig.functions.push({
      identifier: 'reloadBudgetAccountLine',
      fn: this.reloadBudgetAccountLine.bind(this)
    });
    formConfig.functions.push({
      identifier: 'loadProject',
      fn: this.loadProject.bind(this)
    });
    formConfig.functions.push({
      identifier: 'exitProject',
      fn: this.exitProject.bind(this)
    });
    formConfig.functions.push({
      identifier: 'newLot',
      fn: this.newLot
    });
    formConfig.functions.push({
      identifier: 'noVisibleMinorAndCBAM',
      fn: this.contractValidations.noVisibleMinorAndCBAM
    });
    formConfig.functions.push({
      identifier: 'isIncome',
      fn: this.contractValidations.isIncome
    });
    formConfig.functions.push({
      identifier: 'noVisibleEntityNoPanap',
      fn: this.contractValidations.noVisibleEntityNoPanap
    });
    formConfig.functions.push({
      identifier: 'noVisibleEntityPanapAndNoPanap',
      fn: this.contractValidations.noVisibleEntityPanapAndNoPanap
    });
    formConfig.functions.push({
      identifier: 'noVisibleEntityPanapAndNoPanapTable',
      fn: this.contractValidations.noVisibleEntityPanapAndNoPanapTable
    });
    formConfig.functions.push({
      identifier: 'noVisibleMinor',
      fn: this.contractValidations.noVisibleMinor
    });
    formConfig.functions.push({
      identifier: 'visibleAM',
      fn: this.contractValidations.visibleAM
    });
    formConfig.functions.push({
      identifier: 'visibleCBAM',
      fn: this.contractValidations.visibleCBAM
    });
    formConfig.functions.push({
      identifier: 'noVisibleAM',
      fn: this.contractValidations.noVisibleAM
    });
    formConfig.functions.push({
      identifier: 'noVisibleAMTable',
      fn: this.contractValidations.noVisibleAMTable
    });
    formConfig.functions.push({
      identifier: 'visibleGeneral',
      fn: this.contractValidations.visibleGeneral
    });
    formConfig.functions.push({
      identifier: 'noVisibleAMAndMinor',
      fn: this.contractValidations.noVisibleAMAndMinor
    });
    formConfig.functions.push({
      identifier: 'noVisibleCBAM',
      fn: this.contractValidations.noVisibleCBAM
    });
    formConfig.functions.push({
      identifier: 'visibleMinor',
      fn: this.contractValidations.visibleMinor
    });
    formConfig.functions.push({
      identifier: 'noVisibleCBAMIfNotSeconBinding',
      fn: this.contractValidations.noVisibleCBAMIfNotSeconBinding
    });
    formConfig.functions.push({
      identifier: 'onlyVisibleServicesAndHarmonizedRegulation',
      fn: this.contractValidations.onlyVisibleServicesAndHarmonizedRegulation
    });
    formConfig.functions.push({
      identifier: 'visibleApportioned',
      fn: this.contractValidations.visibleApportioned
    });
    formConfig.functions.push({
      identifier: 'visibleGoods',
      fn: this.contractValidations.visibleGoods
    });
    formConfig.functions.push({
      identifier: 'isVisibleWorks',
      fn: this.contractValidations.isVisibleWorks
    });
    formConfig.functions.push({
      identifier: 'visibleServices',
      fn: this.contractValidations.visibleServices
    });
    formConfig.functions.push({
      identifier: 'enabledTaxRate',
      fn: this.contractValidations.enabledTaxRate
    });
    formConfig.functions.push({
      identifier: 'isVisibleInvitationNumber',
      fn: this.contractValidations.isVisibleInvitationNumber
    });
    formConfig.functions.push({
      identifier: 'isVisibleAwardMethod',
      fn: this.contractValidations.isVisibleAwardMethod
    });
    formConfig.functions.push({
      identifier: 'isVisibleFinalWarranty',
      fn: this.contractValidations.isVisibleFinalWarranty
    });
    formConfig.functions.push({
      identifier: 'isVisibleCBAMSeconBindig',
      fn: this.contractValidations.isVisibleCBAMSeconBindig
    });
    formConfig.functions.push({
      identifier: 'isVisibleIncome',
      fn: this.contractValidations.isVisibleIncome
    });
    formConfig.functions.push({
      identifier: 'isVisibleIncomeTable',
      fn: this.contractValidations.isVisibleIncomeTable
    });
    formConfig.functions.push({
      identifier: 'isVisibleApprovalAwardDate',
      fn: this.contractValidations.isVisibleApprovalAwardDate
    });
    formConfig.functions.push({
      identifier: 'isVisibleExtension',
      fn: this.contractValidations.isVisibleExtension
    });

    formConfig.functions.push({
      identifier: 'isVisibleApprovalAwardDateMinor',
      fn: this.contractValidations.isVisibleApprovalAwardDateMinor
    });
    formConfig.functions.push({
      identifier: 'valueAwardCancellationPercentage',
      fn: this.contractValidations.valueAwardCancellationPercentage
    });
    formConfig.functions.push({
      identifier: 'enabledTaxRateAward',
      fn: this.contractValidations.enabledTaxRateAward
    });
    formConfig.functions.push({
      identifier: 'enabledTaxRateTender',
      fn: this.contractValidations.enabledTaxRateTender
    });
    formConfig.functions.push({
      identifier: 'isvisibleComplementarySystem',
      fn: this.contractValidations.isvisibleComplementarySystem
    });
    formConfig.functions.push({
      identifier: 'visibleHomologationSystem',
      fn: this.contractValidations.visibleHomologationSystem
    });
    formConfig.functions.push({
      identifier: 'noVisibleHomologationSystem',
      fn: this.contractValidations.noVisibleHomologationSystem
    });
    formConfig.functions.push({
      identifier: 'noVisibleEmergency',
      fn: this.contractValidations.noVisibleEmergency
    });
    formConfig.functions.push({
      identifier: 'visibleEmergency',
      fn: this.contractValidations.visibleEmergency
    });
    formConfig.functions.push({
      identifier: 'isVisibleJustificationNegotiated',
      fn: this.contractValidations.isVisibleJustificationNegotiated
    });
    formConfig.functions.push({
      identifier: 'changeClassificationCompanyGroup',
      fn: this.changeClassificationCompanyGroup
    });
    formConfig.functions.push({
      identifier: 'changeClassificationCompanySubgroup',
      fn: this.changeClassificationCompanySubgroup
    });
    formConfig.functions.push({
      identifier: 'valueMultipartida',
      fn: this.valueMultipartida
    });
    formConfig.functions.push({
      identifier: 'valuePlurianual',
      fn: this.valuePlurianual
    });
    formConfig.functions.push({
      identifier: 'valuePlurianualAdj',
      fn: this.valuePlurianualAdj
    });
    formConfig.functions.push({
      identifier: 'isVisibleAuditAwardDate',
      fn: this.contractValidations.isVisibleAuditAwardDate
    });
    formConfig.functions.push({
      identifier: 'isEditableRevisionPrice',
      fn: this.contractValidations.isEditableRevisionPrice
    });
    formConfig.functions.push({
      identifier: 'visibleWorksAndServices',
      fn: this.contractValidations.visibleWorksAndServices
    });
    formConfig.functions.push({
      identifier: 'editableSeconBiding',
      fn: this.editableSeconBiding
    });
    formConfig.functions.push({
      identifier: 'changeNumberAwards',
      fn: this.changeNumberAwards
    });
    formConfig.functions.push({
      identifier: 'changeSecondBindigAM',
      fn: this.changeSecondBindigAM
    });
    formConfig.functions.push({
      identifier: 'changeSecondBindigCB',
      fn: this.changeSecondBindigCB
    });

    formConfig.functions.push({
      identifier: 'editableSeconBidingCB',
      fn: this.editableSeconBidingCB
    });
    formConfig.functions.push({
      identifier: 'valueFinalGuaranteeAAM',
      fn: this.valueFinalGuaranteeAAM
    });
    formConfig.functions.push({
      identifier: 'valueChangeAAM',
      fn: this.valueChangeAAM
    });
    formConfig.functions.push({
      identifier: 'valueChangeDSH',
      fn: this.valueChangeDSH
    });
    formConfig.functions.push({
      identifier: 'valueChangeSDA',
      fn: this.valueChangeSDA
    });
    formConfig.functions.push({
      identifier: 'visibleAMAndMinor',
      fn: this.contractValidations.visibleAMAndMinor
    });
    formConfig.functions.push({
      identifier: 'visibleApprovalDate',
      fn: this.visibleApprovalDate
    });
    formConfig.functions.push({
      identifier: 'visibleTenderDocumentApprovalDate',
      fn: this.visibleTenderDocumentApprovalDate
    });
    formConfig.functions.push({
      identifier: 'visibleBudgetAccountLines',
      fn: this.visibleBudgetAccountLines
    });
    formConfig.functions.push({
      identifier: 'valueCompany',
      fn: this.valueCompany
    });
    formConfig.functions.push({
      identifier: 'visibleAwardCancellationPercentage',
      fn: this.contractValidations.visibleAwardCancellationPercentage
    });
    formConfig.functions.push({
      identifier: 'valueOrganizationalUnitAM',
      fn: this.valueOrganizationalUnitAM
    });

    formConfig.functions.push({
      identifier: 'valueRegisterSystemAM',
      fn: this.contractValidations.valueRegisterSystemAM
    });
    formConfig.functions.push({
      identifier: 'valueAllowIntOffers',
      fn: this.valueAllowIntOffers
    });
    // Metodo que se ejecuta al cambiar el valor de la versión normativa
    formConfig.functions.push({
      identifier: 'changeComplementarySystem',
      fn: this.changeComplementarySystem
    });
    // Metodo que se ejecuta al cambiar el valor del procedimiento de contratación
    formConfig.functions.push({
      identifier: 'changeTypeCode',
      fn: this.changeTypeCode
    });
    // Metodo que se ejecuta al cambiar el valor del tipo de expediente
    formConfig.functions.push({
      identifier: 'changeType',
      fn: this.changeType
    });
    // Metodo que calcula los campos de la unidad organizativa al cambiar la unidad promotora
    // implica llamada a servidor, puesto que se calcula con atributos
    formConfig.functions.push({
      identifier: 'changeContractPromoterUnit',
      fn: this.changeContractPromoterUnit
    });
    formConfig.functions.push({
      identifier: 'valueContractTitle',
      fn: this.contractValidations.valueContractTitle
    });
    formConfig.functions.push({
      identifier: 'editableNumberAwards',
      fn: this.contractValidations.editableNumberAwards
    });
    formConfig.functions.push({
      identifier: 'changeApplicableLegislation',
      fn: this.changeApplicableLegislation
    });
    formConfig.functions.push({
      identifier: 'editableCPVs',
      fn: this.editableCPVs
    });
    formConfig.functions.push({
      identifier: 'visibleContractTendererLotInvited',
      fn: this.visibleContractTendererLotInvited
    });
    formConfig.functions.push({
      identifier: 'setValue_PymeContractTender',
      fn: this.contractValidations.setValue_PymeContractTender
    });
    formConfig.functions.push({
      identifier: 'adapt_addRelatedOrderProject',
      fn: this.adapt_addRelatedOrderProject
    });
    formConfig.functions.push({
      identifier: 'visibleCpvsExpediente',
      fn: this.visibleCpvsExpediente
    });
    formConfig.functions.push({
      identifier: 'visibleCSDA',
      fn: this.contractValidations.visibleCSDA
    });
    formConfig.functions.push({
      identifier: 'valueFilterReservedType',
      fn: this.contractValidations.valueFilterReservedType
    });
    formConfig.functions.push({
      identifier: 'editableReservedContractType',
      fn: this.contractValidations.editableReservedContractType
    });
    formConfig.functions.push({
      identifier: 'visibleTenderByContractor',
      fn: this.visibleTenderByContractor
    });
    formConfig.functions.push({
      identifier: 'visibleOutosourcingTypeGeneral',
      fn: this.contractValidations.visibleOutosourcingTypeGeneral
    });
    formConfig.functions.push({
      identifier: 'editableOutsourcingTypeGeneral',
      fn: this.contractValidations.editableOutsourcingTypeGeneral
    });
    formConfig.functions.push({
      identifier: 'visibleOutosourcingTypeBasedContract',
      fn: this.contractValidations.visibleOutosourcingTypeBasedContract
    });
    formConfig.functions.push({
      identifier: 'editableReservedContract',
      fn: this.contractValidations.editableReservedContract
    });
    formConfig.functions.push({
      identifier: 'valueTextLot',
      fn: this.valueTextLot
    });
    formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.contractValidations.loadOrganizationalSnapshotData
    });
    formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.contractValidations.changeProjectOrganizationalSnapshot
    });
    formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.contractValidations.visiblePreviousOrganizationalUnitRegistration
    });
    formConfig.functions.push({
      identifier: 'valueFullNameRepresentative',
      fn: this.valueFullNameRepresentative
    });
    formConfig.functions.push({
      identifier: 'isVisibleRepresentatives',
      fn: this.isVisibleRepresentatives
    });
    formConfig.functions.push({
      identifier: 'isVisibleClassificationCompany',
      fn: this.isVisibleClassificationCompany
    });
    return super.configureFormConfig(formConfig);
  }

  private cleanWorkContract() {
    // this.waitService.startWaiting();
    if (this.model) {
      this.task.work.contract = this.model.dto;
      console.log('***TASK***');
      console.log(this.task.work.contract);
      console.log(
        JSON.parse(
          JSON.stringify(this.task.work.contract, (k, v) =>
            k === '_parent' ? undefined : v
          )
        )
      );
      this.task.work.contract = JSON.parse(
        JSON.stringify(this.task.work.contract, (k, v) =>
          k === '_parent' ? undefined : v
        )
      );
    }
  }



  registerContract(contract: ContractDTO) {
    this.waitService.startWaiting();
    if (contract.identifier) {
      this.subscribe(this.plycaService
        .update<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, contract)
        .pipe(
          finalize(() => {
            this.waitService.cancelWaiting();
          })
        )
      );
    } else {
      this.subscribe(this.plycaService
        .insert<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, contract)
        .pipe(
          finalize(() => {
            this.waitService.cancelWaiting();
          })
        )
      );
    }
  }

  openCPVSelector() {
    let contextSearch = new SearchSettingDTOModal('', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };

    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchCPVComponent, config);
    return ref.onClose.pipe(
      map(
        result => {
          if (result) {
            let contractCpv = new ContractCPVDTO();
            let cpv = new CPVDTO();
            cpv.identifier = result.identifier;
            cpv.description = result.description;
            contractCpv.cpv = cpv;
            return contractCpv;
          }
        }
      )
    )
  }

  goToDossierInfo(_contract: ContractDTO) {
    this.router.navigate(['dossierInfo/' + _contract.division.project.identifier], {
      queryParams: { component: 'CONTRACTS' }
    });
    // this.waitService.cancelWaiting();
  }


  changeClassificationCompanyGroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanyCategory', model, changes);
    let reset = ContractComponent.resetChange(changes);
    if (reset) {
      model._parent.dto.contractClassificationSchemaLot.forEach(contractClassification => {
        if (contractClassification.classification.group.identifier === changes.newValue.identifier) {
          contractClassification.classification.subgroup = undefined;
          contractClassification.classification.category = undefined;
        }
      });
      model.classification.subgroup = undefined;
      model.classification.category = undefined;

    }
  }

  changeClassificationCompanySubgroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanySubgroup', model, changes);
    let reset = ContractComponent.resetChange(changes);
    if (reset) {
      // si se cambia el subgrupo hay que resetear la categoria
      model._parent.dto.contractClassificationSchemaLot.forEach(contractClassification => {
        if (contractClassification.classification.subgroup.identifier === changes.newValue.identifier) {
          contractClassification.classification.category = undefined;
        }
      });
      model.classification.category = undefined;
    }
  }


  public isSettlementMode(model: any) {
    let result = false;
    if (this.task && this.task.work && this.task.work.context && this.task.work.context.configurations) {
      if (this.task.work.context.configurations.settlementAction) {
        if (this.task.work.context.configurations.settlementAction.value) {
          result = true;
        }
      }
    }
    return result;
  }

  getDocument(): DocumentDTO {
    try {
      return this.model.dto['document'];
    } catch { }
  }

  newLot(model: any) {

    console.log('invocacion a newLot', model);
    let nuevoLote;
    if (!model && !model.dto && !model.dto.contractLots) {
      nuevoLote = lodash.cloneDeep(model);
    } else {
      // model.ui.complementarySystem.identifier !== 'AM<>SISTCOMPLEMENTARIO'
      if (model.dto.contractLots && model.dto.contractLots.length > 0) {
        this.uiService.showMessage(
          'No se puede crear más de un lote por contrato.',
          'Aviso',
          'errorStyle'
        );
      } else {
        nuevoLote = new ContractLotDTO();
        nuevoLote.lot = new LotDTO;
      }
    }

    return nuevoLote;

  }

  public valueChangeSDA(model: any) {
    model.dto.originalContractingSystemID = model.ui.originalContractSDA;
    // Si es un contrato basado se debe cargar los cpvs del AM seleccionado. Se debe hacer en la
    if (model.dto.originalContractingSystemID) {
      if (!model.dto.totalLots) {
        model.dto.totalLots = new ContractLotDTO();
      }
      model.dto.totalLots.cpvs = [];

      if (model.dto.originalContractingSystemID.procurementProjectInfo.apportioned) {
        if (model.dto.originalContractingSystemID.contractLots) {
          model.dto.originalContractingSystemID.contractLots.forEach(contractLot => {
            if (contractLot.cpvs) {
              contractLot.cpvs.forEach(cpv => {
                cpv.identifier = undefined;
                model.dto.totalLots.cpvs.push(cpv);
              })
            }

          });
        }
        // model.dto.totalLots.cpvs = cpvAux;
      } else if (model.dto.originalContractingSystemID.totalLots) {
        model.dto.originalContractingSystemID.totalLots.cpvs.forEach(cpv => {
          cpv.identifier = undefined;
          // cpvAux.push(cpv);
          model.dto.totalLots.cpvs.push(cpv);
        });
        // model.dto.totalLots.cpvs = cpvAux;
      }
    }
  }

  public valueChangeDSH(model: any, changes?: any) {
    if (model.ui.homologationSystem) {
      model.dto.totalLots.cpvs = [];
      let cpv = model.ui.homologationSystem.cpv;

      let contractCPVDTO = new ContractCPVDTO();
      contractCPVDTO.cpv = cpv;
      model.dto.totalLots.cpvs.push(contractCPVDTO);
    }
  }


  public valueChangeAAM(model: any) {
    model.dto.originalContractingSystemID = model.ui.originalContractAM;
    // Si es un contrato basado se debe cargar en la empresa del contrato la del AM seleccionado
    if (model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
      model.ui.companySelectedCBAM = new CompanyDTO();
      if (model.dto.originalContractingSystemID !== undefined && model.dto.originalContractingSystemID &&
        model.dto.originalContractingSystemID.company !== undefined && model.dto.originalContractingSystemID.company) {

        let cliente = this.appConfig.getValue('cliente');
        if (cliente === 'AYMAD') {
          model.ui.companySelectedCBAM = model.dto.originalContractingSystemID.company;
          // Es necesario añadir las UTES, se consulta el historico del CompanyDoc
          let identifier = model.dto.originalContractingSystemID.division.project.identifier;
          let division = getSimpleIdentifierFromString(model.dto.originalContractingSystemID.division.identifier);

          model.ui.companySelectedCBAM.temporaryConsortium =
            model.dto.originalContractingSystemID.actualCompany.temporaryConsortium; // am.companyDoc[0].temporaryConsortium;
          model.ui.companySelectedCBAM.companyDoc = model.dto.originalContractingSystemID.actualCompany; // am.companyDoc[0];
          if (model.ui.companySelectedCBAM.temporaryConsortium !== undefined && model.ui.companySelectedCBAM.temporaryConsortium) {

            let listaMemberUte: Array<ConsortiumParticipationDTO> = [];
            model.ui.companySelectedCBAM.companyDoc.consortiumParticipations.forEach(consortiumParticipation => {
              let consortiumParticipationAux = new ConsortiumParticipationDTO();
              consortiumParticipationAux.memberUTE = consortiumParticipation;
              consortiumParticipationAux.memberUTE.nationality.description = consortiumParticipation.nationalityDesc
              consortiumParticipationAux.percentage = consortiumParticipation.percentage;
              listaMemberUte.push(consortiumParticipationAux);
            });
            model.ui.companySelectedCBAM.consortiumParticipations = listaMemberUte;
          }
        } else {
          if (model.ui.companySelected === undefined) {
            model.ui.companySelected = new CompanyDTO();
          }
          model.ui.companySelected.tenderer = model.dto.originalContractingSystemID.company;
          // Es necesario añadir las UTES, se consulta el historico del CompanyDoc
          let identifier = model.dto.originalContractingSystemID.division.project.identifier;
          let division = getSimpleIdentifierFromString(model.dto.originalContractingSystemID.division.identifier);

          model.ui.companySelected.tenderer.temporaryConsortium =
            model.dto.originalContractingSystemID.actualCompany.temporaryConsortium; // am.companyDoc[0].temporaryConsortium;
          model.ui.companySelected.tenderer.companyDoc = model.dto.originalContractingSystemID.actualCompany; // am.companyDoc[0];
          if (model.ui.companySelected.tenderer.temporaryConsortium !== undefined
            && model.ui.companySelected.tenderer.temporaryConsortium) {

            let listaMemberUte: Array<ConsortiumParticipationDTO> = [];
            model.ui.companySelected.tenderer.companyDoc.consortiumParticipations.forEach(consortiumParticipation => {
              let consortiumParticipationAux = new ConsortiumParticipationDTO();
              consortiumParticipationAux.memberUTE = consortiumParticipation;
              consortiumParticipationAux.memberUTE.nationality.description = consortiumParticipation.nationalityDesc
              consortiumParticipationAux.percentage = consortiumParticipation.percentage;
              listaMemberUte.push(consortiumParticipationAux);
            });
            model.ui.companySelected.tenderer.consortiumParticipations = listaMemberUte;
          }
        }



      }

    }

    // Si es un contrato basado se debe cargar los cpvs del AM seleccionado. Se debe hacer en la
    if (model.dto.originalContractingSystemID) {
      // let cpvAux: Array<ContractCPVDTO> = [];
      if (model.dto.totalLots === undefined) {
        model.dto.totalLots = new ContractLotDTO();
      }
      model.dto.totalLots.cpvs = [];

      if (model.dto.originalContractingSystemID.procurementProjectInfo.apportioned) {
        if (model.dto.originalContractingSystemID.contractLots) {
          model.dto.originalContractingSystemID.contractLots.forEach(contractLot => {
            if (contractLot.cpvs) {
              contractLot.cpvs.forEach(cpv => {
                cpv.identifier = undefined;
                model.dto.totalLots.cpvs.push(cpv);
              })
            }

          });
        }
        // model.dto.totalLots.cpvs = cpvAux;
      } else if (model.dto.originalContractingSystemID.totalLots && model.dto.originalContractingSystemID.totalLots.cpvs) {
        model.dto.originalContractingSystemID.totalLots.cpvs.forEach(cpv => {
          cpv.identifier = undefined;
          // cpvAux.push(cpv);
          model.dto.totalLots.cpvs.push(cpv);
        });
        // model.dto.totalLots.cpvs = cpvAux;
      }




      if (model.dto.originalContractingSystemID.secondBindigAM
        && ContractValidations.isMixedBinding(model.dto.originalContractingSystemID.secondBindigAM)) {
        model.dto.secondBindigCB = undefined;
      } else {
        if (!model.dto.originalContractingSystemID.secondBindigAM) {
          model.dto.secondBindigCB = <MasterDataDTO>{
            identifier: '0<>TIPO_LICITACION',
            description: 'Sin nueva licitación'
          };
        } else {
          model.dto.secondBindigCB = model.dto.originalContractingSystemID.secondBindigAM;
        }
      }

      if (ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)
        || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)) {
        if (model.dto.originalContractingSystemID.awardsByLot !== undefined
          && model.dto.originalContractingSystemID.awardsByLot.length > 0) {
          if (model.dto.contractLots === undefined) {
            // let listaLotes: Array<ContractLotDTO> = [];
            let lote0 = new ContractLotDTO();
            let lot = new LotDTO();
            lot.lotId = 0;
            lote0.lot = lot;
            // listaLotes[0] = lote0;
            model.dto.contractLots = [];
            model.dto.contractLots.push(lote0);
          }
          model.dto.contractTendererLotInvited = [];
          model.dto.contractLots.forEach(contractLot => {
            // contractLot.contractTendererLotInvited = undefined;
            model.dto.originalContractingSystemID.awardsByLot.forEach(tenderer => {
              let tendererLot = new ContractTendererLotDTO();
              tendererLot.tenderer = tenderer.tenderer;
              tendererLot.pyme = tenderer.pyme;
              tendererLot.contractLot = contractLot;
              // contractTendererLot.push(tendererLot);
              model.dto.contractTendererLotInvited.push(tendererLot);
            });
            // contractLot.contractTendererLotInvited = contractTendererLot;
            // model.dto.contractTendererLotInvited = contractLot.contractTendererLotInvited;
            if (model.dto.contractTendererLotInvited && model.dto.contractTendererLotInvited.length > 0) {
              model.dto.invitationNumber = model.dto.contractTendererLotInvited.length;
            }
          });
          // this.model.dto.contractLots = model.dto.contractLots;
        }
      }

      if (model.dto.originalContractingSystemID.procurementProjectInfo
        && model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee) {
        if ((model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '1<>TIPO_GARANTIA_AM' ||
          model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '2<>TIPO_GARANTIA_AM')) {
          model.dto.budget.finalFinancialGuaranteeAAM = false;
        }
        if (model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '3<>TIPO_GARANTIA_AM') {
          model.dto.budget.finalFinancialGuaranteeAAM = true;
        }
      }

      // Si es automatico, y es un basado --> Si el AM no es reservado, no tiene que ser editable.
      // Si el AM es reservado --> Tiene que estar editable.
      if (!model.ui.isAutomaticMode && model.dto.contractClassification !== undefined) {
        if (model.dto.originalContractingSystemID.contractClassification !== undefined) {
          let originalContractingSystemReserved = model.dto.originalContractingSystemID.contractClassification.reservedContract;
          if (originalContractingSystemReserved !== undefined && !originalContractingSystemReserved) {
            model.dto.contractClassification.reservedContract = originalContractingSystemReserved;
          }
        }
      }

    }
  }

  valueFinalGuaranteeAAM(model: any) {
    let resultado;
    // Si FICHAREG_AM.AM_GAR_DEFINITIVA es "No procede garantía definitiva", bloqueado y valor NO
    // Si FICHAREG_AM.AM_GAR_DEFINITIVA es "En Acuerdo Marco", bloqueado y valor NO
    // Si FICHAREG_AM.AM_GAR_DEFINITIVA es "En Contrato Basado", bloqueado y valor SI
    // Si FICHAREG_AM.AM_GAR_DEFINITIVA es "Dual":
    // · Si Expte es UI - Electrónico, se comprueba la  FICHAEXPTE_CB para el LOTE correspondiente:
    // ·· Despegable Bloquedado y Si valor del campo Check "Garantía definitiva", es marcado, valor "SI", en caso  contrato, valor "NO"
    // · Si Expte no es UI - Electrónico, desplegable activo y obligatorio(Valor Defecto: "")

    // Para que no se recargue si ya tiene valor.
    if (model.dto.budget.finalFinancialGuaranteeAAM !== undefined) {
      resultado = model.dto.budget.finalFinancialGuaranteeAAM;
    } else {
      if (model.dto.originalContractingSystemID && model.dto.originalContractingSystemID.procurementProjectInfo
        && model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee) {
        if ((model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '1<>TIPO_GARANTIA_AM' ||
          model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '2<>TIPO_GARANTIA_AM')) {
          resultado = false;
        }
        if (model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '3<>TIPO_GARANTIA_AM') {
          resultado = true;
        }

        if (model.dto.originalContractingSystemID.procurementProjectInfo.definitiveGuarantee.identifier === '4<>TIPO_GARANTIA_AM') {
          resultado = model.dto.budget.finalFinancialGuaranteeAAM;
        }

      } else {
        resultado = model.dto.budget.finalFinancialGuaranteeAAM;
      }
    }

    return resultado;
  }

  public valuePlurianual(model: any) {
    let resultado = false;
    let year;
    // Si es un AM. Se comparará la Fecha de Inicio de Vigencia del AM de la Ficha RECO,
    // con la Fecha prevista de Fin de Vigencia, y en caso de que tengan distinto año, se considera como plurianual.
    if (ContractValidations.isAM(model.dto)) {
      if (model.dto.plannedPeriod && model.dto.plannedPeriod.startDate && model.dto.plannedPeriod.endDate) {
        if (model.dto.plannedPeriod.startDate.getYear() !== model.dto.plannedPeriod.endDate.getYear()) {
          resultado = true;
        }
      }
    } else {
      if (model.dto && model.dto.budget && model.dto.budget.budgetAccountLines) {
        model.dto.budget.budgetAccountLines.forEach(budgetAccountLine => {
          if (year === undefined) {
            year = budgetAccountLine.year;
          } else {
            if (budgetAccountLine.year && budgetAccountLine.year !== year) {
              resultado = true;
            }
          }
        });
      }
    }
    return resultado;
  }

  public valuePlurianualAdj(model: any) {
    let resultado = false;
    let year;
    // Si es un AM. Se comparará la Fecha de Inicio de Vigencia del AM de la Ficha RECO,
    // con la Fecha prevista de Fin de Vigencia, y en caso de que tengan distinto año, se considera como plurianual.
    if (ContractValidations.isAM(model.dto)) {
      if (model.dto.plannedPeriod && model.dto.plannedPeriod.startDate && model.dto.plannedPeriod.endDate) {
        if (model.dto.plannedPeriod.startDate.getYear() !== model.dto.plannedPeriod.endDate.getYear()) {
          resultado = true;
        }
      }
    } else {
      if (model.dto && model.dto.budget && model.dto.budget.budgetAccountLinesContract) {
        model.dto.budget.budgetAccountLinesContract.forEach(budgetAccountLine => {
          if (year === undefined) {
            year = budgetAccountLine.year;
          } else {
            if (budgetAccountLine.year && budgetAccountLine.year !== year) {
              resultado = true;
            }
          }
        });
      }
    }
    return resultado;
  }

  public valueMultipartida(model: any) {
    let resultado = false;
    let partida;
    if (model.dto && model.dto.budget && model.dto.budget.budgetAccountLines) {
      model.dto.budget.budgetAccountLines.forEach(budgetAccountLine => {
        if (partida === undefined) {
          partida = budgetAccountLine.organic + '-' + budgetAccountLine.functional + '-' + budgetAccountLine.economical;
        } else {
          if (budgetAccountLine.organic && budgetAccountLine.functional && budgetAccountLine.economical) {
            if (budgetAccountLine.organic + '-' + budgetAccountLine.functional + '-' + budgetAccountLine.economical !== partida) {
              resultado = true;
            }
          }
        }
      });
    }
    return resultado;
  }

  public editableSeconBiding(model: any) {
    // Segunda licitacion am. Bloqueado y sin tipo de licitación
    if (model.dto.numberAwards && model.dto.numberAwards > 1) {
      return true;
    }
    return false;
  }

  public changeNumberAwards(model: any) {
    if (model.dto.numberAwards && model.dto.numberAwards > 1) {
      this.model.dto.secondBindigAM = undefined;
      model.dto.procurementProjectInfo.maximumNumberCompaniesSelect = undefined;
    } else {
      // Segunda licitacion am. Bloqueado y sin tipo de licitación
      this.model.dto.secondBindigAM = <MasterDataDTO>{
        identifier: '0<>TIPO_LICITACION',
        description: 'Sin nueva licitación'
      };
      model.dto.procurementProjectInfo.maximumNumberCompaniesSelect = undefined;
    }
  }

  public changeSecondBindigAM(model: any) {
    if (model.dto.secondBindigAM !== undefined && ContractValidations.isAutomaticBinding(model.dto.secondBindigAM)) {
      model.dto.procurementProjectInfo.maximumNumberCompaniesSelect = model.dto.numberAwards;
    } else {
      model.dto.procurementProjectInfo.maximumNumberCompaniesSelect = undefined;
    }

  }

  public changeSecondBindigCB(model: any) {

    this.model.dto.secondBindigCB = model.dto.secondBindigCB;
    if (model.dto.secondBindigCB !== undefined && (ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)
      || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB))) {
      if (model.dto.originalContractingSystemID.awardsByLot !== undefined
        && model.dto.originalContractingSystemID.awardsByLot.length > 0) {
        if (model.dto.contractLots === undefined) {
          // let listaLotes: Array<ContractLotDTO> = [];
          let lote0 = new ContractLotDTO();
          let lot = new LotDTO();
          lot.lotId = 0;
          lote0.lot = lot;
          // listaLotes[0] = lote0;
          model.dto.contractLots = [];
          model.dto.contractLots.push(lote0);
        }
        model.dto.contractTendererLotInvited = [];
        model.dto.contractLots.forEach(contractLot => {
          // contractLot.contractTendererLotInvited = undefined;
          model.dto.originalContractingSystemID.awardsByLot.forEach(tenderer => {
            let tendererLot = new ContractTendererLotDTO();
            tendererLot.tenderer = tenderer.tenderer;
            tendererLot.pyme = tenderer.pyme;
            tendererLot.contractLot = contractLot;
            // contractTendererLot.push(tendererLot);
            model.dto.contractTendererLotInvited.push(tendererLot);
          });
          // contractLot.contractTendererLotInvited = contractTendererLot;
          // model.dto.contractTendererLotInvited = contractLot.contractTendererLotInvited;
          if (model.dto.contractTendererLotInvited && model.dto.contractTendererLotInvited.length > 0) {
            model.dto.invitationNumber = model.dto.contractTendererLotInvited.length;
          }
        });
        // this.model.dto.contractLots = model.dto.contractLots;
      }

    }

  }



  public editableSeconBidingCB(model: any) {
    // Segunda licitacion am. Bloqueado y sin tipo de licitación
    if (model.ui.isAutomaticMode) {
      return false;
    }
    if (model.dto.originalContractingSystemID && model.dto.originalContractingSystemID.secondBindigAM
      && ContractValidations.isMixedBinding(model.dto.originalContractingSystemID.secondBindigAM)) {
      return true;
    }
    return false;
  }



  public valueTaxIdentifier(model: any) {
    if (this.model.ui.complementarySystem && this.model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
      return model.dto.originalContractingSystemID.company.taxIdentifier;
    } else {
      return model.ui.companySelected.tenderer.taxIdentifier
    }
  }

  public valueCompany(model: any) {
    if (this.model.ui.complementarySystem && this.model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
      if (model.dto.originalContractingSystemID && model.dto.originalContractingSystemID.company) {
        model.ui.companySelectedCBAM = model.dto.originalContractingSystemID.company;
      } else {
        if (this.model.dto.company !== undefined) {
          model.ui.companySelectedCBAM = this.model.dto.company;
        }
      }
      /*if (this.model.dto.company !== undefined) {
        model.ui.companySelectedCBAM = this.model.dto.company;
      } else {
        if (model.dto.originalContractingSystemID.company) {
          model.ui.companySelectedCBAM = model.dto.originalContractingSystemID.company;
        }

      }*/
    }
    return model.ui.companySelectedCBAM;

  }

  public visibleApprovalDate(model: any) {
    let resultado = true;

    if (model.dto.context && model.dto.context.configurations &&
      (model.dto.context.configurations.isNoPanap.value || model.dto.context.configurations.isPanap.value)) {
      resultado = false;
    } else if (model.ui.urgencyCode && model.ui.urgencyCode.identifier === 'E<>CLASEEXPTE') {
      resultado = false;
    } else {
      let isModesMinor = false;
      if (model.ui.type) {
        isModesMinor = model.ui.type.identifier === 'M<>PROCEDIMIENTOSCONTRA';
        if (model.ui.type.properties) {
          isModesMinor =
            isModesMinor || model.ui.type.properties['MODO'] === 'M'
        }
      }
      if (isModesMinor) {
        resultado = false;
      } else {
        if (model.ui.complementarySystem) {
          if (model.ui.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO') {
            resultado = false;
          }
          if (model.ui.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
            if (!model.dto.secondBindigCB || (model.dto.secondBindigCB && (ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB)
              || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)))) {
              return false;
            }
          }

        } else {
          if (model.ui.accountingMotivation
            && model.ui.accountingMotivation.identifier !== '1<>TIPO_MOTIVACION_CONTABLE') {
            resultado = false;
          }
        }
      }
    }

    return resultado;
  }

  public visibleTenderDocumentApprovalDate(model: any) {
    let resultado = true;
    if (ContractValidations.isCBAM(model.ui)) {
      if (!model.dto.secondBindigCB || model.dto.secondBindigCB && ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB)
        || model.dto.secondBindigCB && ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)) {
        resultado = false;
      }
    } else if (ContractValidations.isCSDA(model.ui)) {
      resultado = true;
    } else {
      resultado = false;

    }
    return resultado;

  }

  public visibleBudgetAccountLines(model: any) {
    let resultado = true;
    if (this.model.ui.complementarySystem) {
      if (this.model.ui.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO') {
        let isNoPanap = false;
        if (model.dto.context && model.dto.context.configurations && model.dto.context.configurations.isNoPanap) {
          isNoPanap = model.dto.context.configurations.isNoPanap.value;
        }

        let isPanap = false;
        if (model.dto.context && model.dto.context.configurations && model.dto.context.configurations.isPanap) {
          isPanap = model.dto.context.configurations.isPanap.value;
        }
        if (isPanap || isNoPanap) {
          resultado = false;
        }
      }

    }
    return resultado;
  }


  // Si "Varios Org. Contratación" = NO - Asignar valor de "Unidad de Contratación" y ahora ese combo siempre es NO
  public valueOrganizationalUnitAM(model: any) {
    if (model.dto && model.dto.organizationalInfo) {
      return this.model.dto.organizationalInfo.contractingUnit;
    } else {
      return undefined;
    }

  }

  public valueAllowIntOffers(model: any) {
    return false;
  }

  // Ñapa para que no salga el undefined en el buscador de AM
  public changeComplementarySystem(model: any) {
    if (model.ui.complementarySystem && (model.ui.complementarySystem.identifier ===
      'CBAM<>SISTCOMPLEMENTARIO' || model.ui.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO')) {
      if (model.dto.originalContractingSystemID === undefined) {
        model.dto.originalContractingSystemID = new ContractDTO();
        model.dto.originalContractingSystemID.registrationNumber = '';
      }
    }

    if (model.ui.complementarySystem && model.ui.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO') {
      model.dto.secondBindigCB = <MasterDataDTO>{
        identifier: '1<>TIPO_LICITACION',
        description: 'Con nueva licitación'
      };
    }

    if (model.ui.companySelectedCBAM !== undefined && model.ui.companySelectedCBAM.name === undefined) {
      model.ui.companySelectedCBAM.name = '';
    }

  }

  // Al cambiar la versión normativa deben limpiarse los buscadores que dependen de ella.
  public changeApplicableLegislation(model: any) {
    /*this.uiService.showConfirmMessage({
      message: 'Al modificar la versión normativa . ' +
        '¿Desea precargar la información relacionada?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        model.ui.urgencyCode = undefined;
        model.ui.type = undefined;
        model.ui.typeCode = undefined;
        //Clasificación de empresas
        model.dto.procurementProjectInfo.classification.processJustificationNegotiate = undefined;
        console.log('Limpiando campos vinculados a la versión normativa informacion...');
      },
      reject: () => {
        console.log('No hace nada...');
      }
    });*/
    // Tramitación anticipada
    model.ui.urgencyCode = undefined;
    // Tipo de procedimiento
    model.ui.type = undefined;
    // Tipo de expediente
    model.ui.typeCode = undefined;
    // Clasificación de empresas??
    // Justificación de negociados
    model.dto.procurementProjectInfo.classification.processJustificationNegotiated = undefined;

    this.isVisibleClassificationCompany(model);

  }

  // A realizar si se cambia el procedimiento de contratación
  public changeType(model: any) {
    // Calcular el modo.
    if (model.ui.type && model.ui.type.properties) {
      model.ui.typeCodeMode = model.ui.type.properties['MODO'] !== undefined ?
        model.ui.type.properties['MODO'] : model.ui.type.identifier;
    } else {
      model.ui.typeCodeMode = undefined;
    }
    // Limpiar la justificación de negociado.
    model.dto.procurementProjectInfo.classification.processJustificationNegotiated = undefined;

    // Sistemas dinámicos, Si tenía un valor queremos que lo recupere.
    if (model.ui.type && model.ui.type.identifier === 'DSH<>PROCEDIMIENTOSCONTRA') {
      if (model.dto.homologationSystem !== undefined || model.dto.homologationSystem) {
        model.ui.homologationSystem = model.dto.homologationSystem;
      } else {
        model.dto.homologationSystem = model.ui.homologationSystem;
      }
      // Arrastramos el cpv del derivados de sistema de homologación
      model.dto.totalLots.cpvs = [];
      let cpv = model.dto.homologationSystem.cpv;
      let contractCPVDTO = new ContractCPVDTO();
      contractCPVDTO.cpv = cpv;
      model.dto.totalLots.cpvs.push(contractCPVDTO);
    }
  }
  // A realizar si se cambia el tipo de expediente
  public changeTypeCode(model: any) {
    // Limpiar la justificación de negociados
    model.dto.procurementProjectInfo.classification.processJustificationNegotiated = undefined;
    model.dto.contractClassificationSchemaLot = undefined;

    this.isVisibleClassificationCompany(model);
  }

  public isVisibleClassificationCompany(model: any) {
    let result = true;
    if (model.ui.applicableLegislation &&
      model.ui.type && model.ui.typeCode && (!model.dto.formId || model.dto.formId=='FRC_ADVANCED')) {
      result = model.ui.type.identifier !== 'M<>PROCEDIMIENTOSCONTRA' &&
        model.ui.type.identifier !== 'AAM<>PROCEDIMIENTOSCONTRA' &&
        (model.ui.typeCode.identifier === '01<>TIPOEXPTE'
          || model.ui.typeCode.identifier === '04<>TIPOEXPTE');
    } else {
      return false;
    }
    return result;
  }

  public changeContractPromoterUnit(model: any) {
    if (this.model.dto.organizationalInfo && this.model.dto.organizationalInfo.contractPromoterUnit
      && this.model.dto.organizationalInfo.contractPromoterUnit.identifier) {
      this.model.dto.organizationalInfo.contractingUnit = undefined;
      this.model.dto.organizationalInfo.centerSectionCode = undefined;
      this.model.dto.organizationalInfo.contractingAuthority = undefined;
      this.subscribe(this.plycaService.getOrganizationaUnitInfo(this.model.dto.organizationalInfo.contractPromoterUnit.identifier
      ), ((result2: ContractOrganizationalInfoDTO) => {
        this.model.dto.organizationalInfo = result2;
      }));
    }
  }



  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public editableCPVs() {
    let automaticMode = false;
    let editableSupport = false;
    let anulationMode = false;

    if (this.task && this.task.work && this.task.work.contract) {

      if (this.task.work.contract.division
        && this.task.work.contract.division.project && this.task.work.contract.division.project.documentClass
        && this.task.work.contract.division.project.documentClass.identifier
        && this.task.work.contract.division.project.documentClass.identifier === '00000') {
        automaticMode = true;
      }

      if (this.task.work.contract.context && this.task.work.contract.context.configurations) {
        if (this.task.work.contract.context.configurations.isEditableSupport) {
          editableSupport = this.task.work.contract.context.configurations.isEditableSupport.value;
        }

        if (this.task.work.context.configurations.isAnulationMode) {
          anulationMode = this.task.work.context.configurations.isAnulationMode.value;
        }
      }
    }
    return !anulationMode && (!automaticMode || editableSupport);


  }

  public visibleContractTendererLotInvited(model: any) {
    let resultado = false;
    if (ContractValidations.isMinorContrat(model.ui) && (!model.dto.minorTenderType || model.dto.minorTenderType
      && model.dto.minorTenderType.identifier !== '0<>TIPO_LICITACION_MENOR')) {
      resultado = true;
    } else {
      if (ContractValidations.isCBAM(model.ui)) {
        if (model.dto.secondBindigCB && !ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB)) {
          resultado = true;
        }
      }

    }
    return resultado;
  }

  adapt_addRelatedOrderProject() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    // Vemos los encargos que ya están añadidos, para no mostrarlos en el buscador directamente.
    let excludedOrderProjects = "";
    if (this.model.dto.customFields && this.model.dto.customFields.CUSTOMFIELD_RELATED_ORDERPROJECT) {
      this.model.dto.customFields.CUSTOMFIELD_RELATED_ORDERPROJECT.forEach(relatedOrderProject => {
        if (relatedOrderProject.orderProject && relatedOrderProject.orderProject.identifier) {
          let identifier = relatedOrderProject.orderProject.identifier;
          if (excludedOrderProjects && excludedOrderProjects !== "") {
            excludedOrderProjects = excludedOrderProjects + ",'" + identifier + "'";
          } else {
            excludedOrderProjects = excludedOrderProjects + "'" + identifier + "'";
          }
        }
      });
    }

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = "PROPUESTAS_ENCARGO";
    param1.value = excludedOrderProjects;

    parametersURL.push(param1);
    let completedResult = true;
    let autoSearch = false;
    let searchConfig = new SearchConfig();
    searchConfig.multiSelection = true;
    let contextSearch = new SearchSettingDTOModal(
      'SEARCH_ENCARGO_RELACIONADO',
      autoSearch,
      parametersURL,
      completedResult,
      searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };

    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    return ref.onClose.pipe(
      map((_searchResult: SearchSelectionResultDTO[]) => {
        if (_searchResult && _searchResult.length > 0) {
          let relatedOrderProjects: Array<RelatedOrderProjectDTO> = [];
          _searchResult.forEach(searchSelectionResult => {
            // OJO-No se puede pasar el orderproject y el contract porque falla la deserialización del json en servidor
            let relatedOrderProjectDTO = new RelatedOrderProjectDTO();
            let orderProjectAux = new OrderProjectDTO();
            if (searchSelectionResult.result) {
              orderProjectAux.identifier = searchSelectionResult.result.identifier;
              orderProjectAux.contractFolderId = searchSelectionResult.result.contractFolderId;
              orderProjectAux.name = searchSelectionResult.result.name;
            }
            relatedOrderProjectDTO.orderProject = orderProjectAux;
            let contractAux = new ContractDTO();
            contractAux.identifier = this.model.dto.identifier;
            contractAux.division = new DivisionDTO();
            contractAux.division.identifier = this.model.dto.division.identifier;
            contractAux.class = 'com.nexusit.plyca.api.userAPI.v1.contract.ContractDTO';
            relatedOrderProjectDTO.contract = contractAux;
            relatedOrderProjects.push(relatedOrderProjectDTO);
          });
          return relatedOrderProjects;
        }
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })
    );
  }

  public visibleCpvsExpediente(model: any) {
    let resultado = false;
    if (!ContractValidations.isMinorContrat(model.ui)) {
      resultado = true;
    } else {
      if (model.dto.minorInstruction && model.dto.minorInstruction.identifier === '0<>TIPO_INST_MENOR') {
        resultado = true;
      }

    }
    return resultado;
  }

  protected getTask(): TaskDTO {
    let taskAux = lodash.cloneDeep(this.task);
    taskAux.work.contract = JSON.parse(
      JSON.stringify(taskAux.work.contract, (k, v) =>
        k === '_parent' ? undefined : v
      )
    );
    let dto = this.modelToDTO(lodash.cloneDeep(this.model));
    taskAux.work.contract = dto;
    return taskAux;
  }

  public visibleTenderByContractor(model: any) {
    let visible = false;
    let isCBAM = ContractValidations.isCBAM(model.ui);
    let isAutomaticMode = model.ui.isAutomaticMode;
    let isReserved = model.dto && model.dto.contractClassification && model.dto.contractClassification.reservedContract;
    let reservedType = model.dto && model.dto.contractClassification && model.dto.contractClassification.reservedContractType
      && model.dto.contractClassification.reservedContractType.identifier;
    if ((!isCBAM || (isCBAM && !isAutomaticMode)) && isReserved && reservedType !== undefined) {
      if (reservedType.toString() === '14') {
        visible = true;
      }
    }
    return visible;
  }

  public valueTextLot(model: any) {
    if (model && model.lot && model.lot.description) {
      return model.lot.lotNumber + ' - ' + model.lot.description;
    } else {
      return model.lot.lotNumber;
    }
  }

  public valueFullNameRepresentative(model: any) {
    let description = '';
    if (model && model.name && model.surname) {
      description = RepresentativeDTO.getFullName(model);
      if (model.description) {
        description = description + ' (' + model.description + ')';
      }
      return description
    } else {
      return '';
    }
  }

  public isVisibleRepresentatives(model: any) {
    if (model.ui && model.ui.companySelected && model.ui.companySelected.tenderer && model.ui.companySelected.tenderer.representatives) {
      if (model.ui.companySelected.tenderer.representatives.length > 1) {
        return true;
      }
    }
    return false;
  }

  reloadBudgetAccountLine() {
    this.waitService.startWaiting();
    let marcaTipoPago = this.model.dto.division != null && this.model.dto.division.project != null
      && this.model.dto.division.project.customFields != null
      && this.model.dto.division.project.customFields.MARCA_TIPO_PAGO !=
      null ? this.model.dto.division.project.customFields.MARCA_TIPO_PAGO : null;

    if (this.model.dto.plannedPeriod.startDate === undefined) {
      this.uiService.showMessage(
        'Debe indicarse una fecha de inicio del contrato para realizar el cálculo distribuido del presupuesto.',
        'Aviso',
        'errorStyle'
      );
    } else if (this.model.dto.plannedPeriod.endDate === undefined
      && marcaTipoPago != null && marcaTipoPago != 'A' && marcaTipoPago != 'B') {

      this.uiService.showMessage(
        'Debe indicarse una fecha de fin del contrato para realizar  el cálculo distribuido del presupuesto',
        'Aviso',
        'errorStyle'
      );

    } else {
      let dto = this.modelToDTO(lodash.cloneDeep(this.model));
      this.subscribe(this.plycaService.reloadBudgetAccountLines(dto), ((result: any) => {
        this.model.dto.budget.budgetAccountLines = result;
        this.waitService.cancelWaiting();
      }));
    }
  }


  openMaterialEditor(contract?: ContractDTO) {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TenderInfo.actions.editMaterial'),
      width: '95%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['contract'] = contract;
    config['context'] = context;
    config.data = {
      task: this.task
    };


    this.waitService.startWaiting();


    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));


    this.subscribe(this.dialogService.open(ContractRequestedMaterialListComponent, config).onClose,
      (materialSaved: boolean) => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));

      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }

}
